/* eslint-disable */
var SHOW_PRICES_ALL = 'all'; // показывать сразу все цены
var SHOW_PRICES_ONLY = 'only'; // показывать первые N  цен (5)
var SHOW_PRICES_NONE = 'none'; // скрыть все цены за кнопкой

$.widget("my.hotTable", {

    options: {
        mobile: false,
        debug: false,		//режим отладки - выводит время выполнения скриптов
        showHelp: true,
        showForm: false,
        showFilter: true,
        lazy_loading: false,
        lazy: {},
        makeWrap: true,
        data: null,
        pageButtonCount: 6,
        baseCountView: 15,
        countView: 15,
        pageCount: 0,	//кол-во страниц
        page: 1,	//текущая страница
        paginationType: 'button',	//по умолчанию пагинация через кнопку "смотреть еще N  туров"
        currency: "$",
        filters: [],
        filterParams: {},
        filterCheckedParams: {}, // чекнутые, но пока не примененные фильтры
        tableData: [],
        help_text: "С помощью фильтра Вы сможете быстро найти наиболее подходящий вариант тура.<br /> Попробуйте, это очень удобно!",
        help_title: "Используйте фильтр",
        template: "",
        deleteEmptyFilter: false,	//удалять фильтр без значений?
        addComment: false,			//возможность добавления комментов
        hashList: {},
        useHash: false,			//генерировать хеш строки и убирать дубликаты
        useOperatorHash: false,        //добавить в hash оператора
        hotelRecs: [],				//рекоменадции менеджеров, подгрузка ajax
        checkCheap: false,			//проверять на более дешевые отели
        selectable: false,			//
        firstAdd: false,			//наступило ли событие первого добавления
        addRowsInsert: false,			//вставлять ли новые записи в DOM сразу при добавлении данных в addRows
        group: false,			//группировать отели в выдаче
        groupOnlyBest: true,			//при группировке показывать только лучшие цены
        startWithEmpty: false,		//начинаем с пустой таблицей, не надо прогонять её на analyze
        toggleFilter: false,			//сворачивается ли фильтр
        instantFilter: true,			//фильтровать выдачу, при нажатии на чекбокс фильтра
        markFarResults: false,			//вешать на строку класс far-result, если она далеко и скорее всего будут найдены не все цены
        lazyPrices: false,			    //показывать цены после прелоадера
        findMoreOnFilter: false,		//выполнять поиск, при нажатии на чекбокс фильтра
        findSameTours: false,		    //выполнять поиск, при нажатии на "Больше вариантов"
        autoCheckHotelPrice: false,    //автоматическая проверка цен при прокрутке страницы
        showHelpLine: false,			//показывать ли плашки с предложением помощи и заказа звонка
        editDate: false,			//разрешить редактирование даты
        openedHotels: [],				//список открытых отелей
        onlyFavHotels: false,			//только избранные отели
        onlyBestPrice: false,			//только лучшие цены
        onlyMomentConfirm: false,		//только отели на моментальном подтверждении
        onlyGuaranteeConfirm: false,	//только
        onlyPremium: false,	            //только премиум отели
        sortable: false,			//возможность сортировки
        sortBy: 'price',			//поле для сортировки по умолчанию
        sortFilters: {					//поля, по которым можно сортировать
            price: {
                name: 'Цена',
                direct: 'ASC',
            }
        },
        sortParams: {
            sortFilterParentSelector: '',
        },
        b: {
            start: '{{',
            end: '}}'
        },
        showMarkups: false,
        templates: {
            zeroVisibleItem: '',
            cntText: '({{cnt}} вар.)',
            hotels: {
                main: ' \
					<h2 class="cheap_hotels_name">{{hotel_name}}</h2>\
					<table class="cheap_hotels_list" id="cheap_hotels_list_{{hotel_id}}">\
						<thead>\
							<tr>\
								<th class="cheap_hotels_date">Дата</th>\
								<th class="cheap_hotels_city">Вылет</th>\
								<th class="cheap_hotels_days">Дни</th>\
								<th class="cheap_hotels_meal">Питание</th>\
								<th class="cheap_hotels_operator">Оператор</th>\
								<th class="cheap_hotels_price">Цена</th>\
								<th class="cheap_hotels_filter">Фильтр</th>\
								<th></th>\
							</tr>\
						</thead>\
						<tbody>\
							{{tbody}}\
						</tbody>\
					</table>\
				',
                row: ' \
					<tr class="{{even}} {{new}} {{selected}}">\
						<td class="cheap_hotels_date">{{date}}</td>\
						<td class="cheap_hotels_city">{{city}}</td>\
						<td class="cheap_hotels_days">{{days}}</td>\
						<td class="cheap_hotels_meal">{{meal}}</td>\
						<td class="cheap_hotels_operator">{{operator}}</td>\
						<td class="cheap_hotels_price">{{price}}</td>\
						<td class="cheap_hotels_filter">{{filter}}</td>\
						<td>\
							{{button}}\
						</td>\
					</tr>\
				'
            }
        },
        texts: {
            same: ['вариант', 'варианта', 'вариантов']
        },
        images_path: {
            star: '/img/star2.png',
            star_muted: '/img/star2_muted.png'
        },
        mutedStar: false,					//делать ли mute звездам
        renderFilter2: null,				//метод, рисующий фильтр
        renderFilterData: null,			//метод, рисующий данные фильтра
        renderFilterItem: null,			//метод, рисующий элемент фильтра
        checkVisible: null,				//своя проверка какие результаты показывать
        calcFilters: null,
        elems: {
            'pagination': null,
        },
        // onAfterRefresh 	: null,
        onAfterFilter: null,
        mode: 'list',
        showPrices: true,					// показывать все цены или только первые 5
        showPricesMode: SHOW_PRICES_ALL,
        isTable: true,                      // Работаем как с таблицей или ориентируемся на клаccы
        refreshFilterDesc: false,           // Текстом список фильтров
        countVisible: 0,           			// Количество видимых туров
        moreHotelsPlace: '',           		// Как показывать еще отели '' || 'mpopup'
        onlyCheckedHotels: false,
        tourViewUrlParams: '',              // дополнительные get параметры view тура
    },

    //внутренние переменные
    _options: {
        elems: {
            'filter': null,
            'help': null,
            'form': null,
            'button': null,
            'pagination': null,
        }
    },

    _setOption: function (key, value) {
        if (key == 'data') {
            window.hotTableData = value;
        }
        if (key == 'elem_filter') {
            return;
        }
        // далее вызываем стандартные действия по изменению свойств
        $.Widget.prototype._setOption.apply(this, arguments);
    },

    // конструктор плагина.
    _create: function () {
        //log('create\n');
        if (this.options['debug']) tmSt('_create');
        var renderTable = false;	//надо ли рисовать таблицу
        // Если данные не были переданы, парсим таблицу на их наличие
        this._analyzeTable();
        /*
         if(this.options['data'] === null){
         this._analyzeTable();
         }else{
         renderTable = true;
         // Иначе проверяем данные на корректность
         this._analyzeData();
         }
         */
        //log('afterAnalyze');
        //debug(this.options.filters);
        if (this.options['data'] === null) {
            //$.error( 'Некорректный источник данных для my.hotTable' );
            return false;
        }

        // Заполняем таблицу данными
        if (renderTable === true) {
            this._renderTable();
        }

        if (this.options.elem_filter) {
            this._options.elems.filter = this.options.elem_filter;
        }
        if (this.options.elem_page) {
            this.options.elems.pagination = this.options.elem_page;
        }
        if (this.options['showFilter'] === true) {
            this._renderFilter();
        }

        if (this.options['lazy_loading']) {
            this.options['lazy'](function () {
                /*
                 if(this.options['showFilter'] === true){
                 this._renderFilter();				}

                 //Обновляем таблицу
                 if(!this.options['startWithEmpty'])
                 this._refresh();
                 */
            });
        } else {
            //Обновляем таблицу
            if (!this.options['startWithEmpty'])
                this._refresh();
        }

        this.element.addClass('ht_results_wrap');
        // Вешаем обработчики по нажатию
        this._handlers();
        //Показываем подсказку
        if (this.options['showHelp'] === true && this._options['elems'].help) {
            this._options['elems'].help.show();
        }
        this.options.countView = this.options.baseCountView;

        // генерация события create
        this._trigger("createTable", null, {});
        if (this.options['debug']) tmEnd('_create');
    },

    // деструктор плагина
    destroy: function () {
        // генерация события destroy
        this._trigger("destroy");
    },

    //Отрисовка отдельного элемента фильтра
    _renderFilterItem: function (ff_key, vv) {
        //if(this.options['debug'])	tmSt('_renderFilterItem');
        var td = '', ii;
        var ffParams = this.options['filterCheckedParams'];
        var isSelected = typeof(ffParams[ff_key]) !== 'undefined' && ffParams[ff_key].indexOf(vv['value']) !== -1;
        if (this.options.isTable) {
            td += "<label class='visible'>";
        } else {
            td += "<div class='item'><button type='button' class='btn-clear btn-checkbox visible" + (isSelected ? ' checked' : '') + "'>";
        }
        td += "<input type='checkbox' value=\"" + vv['value'] + "\" " + (isSelected ? ' checked' : '') + "/><span class='sp' title=\"" + vv['count'] + " " + getnoun(vv['count'], 'тур', 'тура', 'туров') + "\"> ";
        switch (ff_key) {
            case 'class':
                if (parseInt(vv['value'])) {
                    var cc = parseInt(vv['value']);
                    for (ii = 1; ii <= cc; ii++) {
                        td += "<img src='/img/star3.png' />";
                    }
                    for (ii = cc + 1; ii <= 5; ii++) {
                        //td+="<img src='/img/star3_muted.png' />";
                    }
                } else {
                    td += vv['value'];
                }
                break;
            case 'operator':
                td += vv['value'];
                if (0 && this.options.showMarkups && typeof(window.toursMarkup) != "undefined" &&
                    window.toursMarkup.hasOwnProperty(vv['value'])) {
                    var tip = "", tipText = "нет комментария";
                    if (window.toursMarkup[vv['value']]['reason'] != "") {
                        tipText = window.toursMarkup[vv['value']]['reason'];
                    }
                    tipText += '. ' + window.toursMarkup[vv['value']]['managerName'];
                    tip = 'data-toggle="tooltip" data-placement="top" title="' + tipText + '"';
                    td += " <span class='tourMarkup' " + tip + ">(" + (window.toursMarkup[vv['value']]['price'] > 0 ? "+" : "") + window.toursMarkup[vv['value']]['price'] + (parseInt(window.toursMarkup[vv['value']]['isPercent']) ? "%" : '') + ")</span>";
                }
                break;
            case 'nights':
                td += vv['value'] + " " + getnoun(vv['value'], 'день', 'дня', 'дней');
                break;
            case 'recs':
            case 'rcmGood':
                td += '<img src="/img/hico/hotel_like.png" /> ' + vv['value'];
                break;
            case 'isHotelIdNull':
                var nullIdLabel = vv['value'] === '1' ? 'Склеен' : 'Не склеен';
                td += '<span>' + nullIdLabel + '</span>';
                break;
            default:
                td += vv['value'];
                break;
        }
        var tpl = this.options.templates.cntText;
        tpl = tpl.split('{{cnt}}').join(vv['count']);
        td += " " + "<span class='count'>" + tpl + "</span></span>";
        if (this.options.isTable) {
            td += "</label>";
        }
        else {
            td += "</button></div>";
        }
        //if(this.options['debug'])	tmEnd('_renderFilterItem');
        return td;
    },

    //Отрисовка данных фильтра
    _renderFilterData: function () {
        if ('function' == typeof(this.options.renderFilterData)) {
            if (this.options['debug']) tmSt('_renderFilterData');
            this.options.renderFilterData(this);
            if (this.options['debug']) tmEnd('_renderFilterData');
            return;
        }
        if (this.options['debug']) tmSt('_renderFilterData');
        //Рисуем суперфильтр
        var ff, vv, th = '', td = '', ff_key, v_key,
            filters = this.options['filters'],
            is_wrap = this.options['makeWrap'],
            $filter = this._options['elems'].filter || null;
        if ($filter === null) return;

        //html = '';
        for (ff_key in filters) {
            ff = filters[ff_key];
            //if(count(ff['values']) <= 1) continue;
            //Добавляем заголовок
            th += "<th class='hotTable_filter_item_" + ff_key + (ff.hideOnHotelsSearch ? ' hide-on-hotels-search' : '') + "'>";
            th += ff['title'];
            th += "</th>";
            //$(selector+"Filter thead tr:eq(1)").append(th);
            //Добавляем внутренности
            td += '<td class="filter_' + ff['name'] + (ff.hideOnHotelsSearch ? ' hide-on-hotels-search' : '') + '">';
            td += "<div id='filterTbl_" + ff['name'] + "' class='filterTbl filterTbl_" + ff['name'] + "' data-name='" + ff['name'] + "'>";
            td += "<div class='values'>";

            for (v_key in ff['values']) {
                vv = ff['values'][v_key];
                td += this._renderFilterItem(ff_key, vv);
                vv['rendered'] = true;
            }

            td += "</div></div>";
            td += '</td>';
            //$(selector+"Filter tbody tr").append(td);
        }
        $filter.find('.filterHead').html(th);
        $filter.find('.filterBody').html(td);

        this._setOption('filters', filters);
        //log('renderFilter');
        //debug(this.options.filters);
        if (this.options['debug']) tmEnd('_renderFilterData');
    },

    //Отрисовка каркаса фильтра
    _renderFilter: function () {
        if (this.options['debug']) tmSt('_renderFilter');

        this._renderPagination();
        var html = "";
        //Рисуем суперфильтр
        if ("renderFilter2" in this.options && typeof(this.options.renderFilter2) == 'function') {
            html = this.options.renderFilter2(this);
        } else {
            var filters = this.options['filters'],
                is_wrap = this.options['makeWrap'];
            html = '';
            //html += "<div class='tableBorder resultsFilterBorder rel'></div>";
            html += "<div class='hotFilter rel'>";
            html += '<div id="super_help" class="" style="opacity: 1;"><span class="close_super_help"></span><h3>' + this.options['help_title'] + '</h3><p>' + this.options['help_text'] + '</p></div>';
            if (is_wrap) {
                html += "<div class='hf-title " + (this.options['toggleFilter'] ? "hf-title__toggable" : "") + "'>";
                html += "<div class='hf-icon fl_l'><img src='/img/options.png' alt=''></div>";
                html += "<div class='hf-text fl_l'>";
                html += "<p>Воспользоваться фильтрами для поиска</p>";
                html += "<p class='hf-text__hint'>Выбрать звездность, регион, количество дней и питание</p>";
                html += "</div>";
                if (this.options['toggleFilter']) {
                    html += "<div class='hf-button fl_r'><div class='hf-button-arrow hf-button-arrow__down'></div></div>";
                }
                html += "<div class='cb clearfix'></div>";
                html += "</div>";
            }
            html += "<div class='hf-body tableBorder " + (this.options['toggleFilter'] ? ""/*"hide"*/ : "") + "'>";
            html += "<table id='resultsFilter' class='tblResults hotTable_filter_" + count(filters);
            html += (is_wrap) ? " tblResults__beauty " : "";
            html += " tableSuperFilter tblOrange'>";
            html += "<thead>";
            html += "<tr class='filterHead'>";
            html += "</tr>";
            html += "</thead>";
            html += "<tbody>";
            html += "<tr class='filterBody'>";
            html += "</tr>";
            html += "</tbody>";
            html += "</table>";
            html += "</div>";
            html += "</div>";
            html += "<div class='cb'></div>";
            html += "<div class='hotTips'></div>";
            //Request form
            if (this.options['showForm'] === true) {
                html += '<table id="resultsForm" class="tblResults tableSuperForm tblOrange">';
                html += '<thead>';
                html += '<tr>';
                html += '<th class="resultsFormHead"><img src="/img/man-in-the-circle.png" alt=""><p>Помощь менеджера</p></th>';
                html += '</tr>';
                html += '</thead>';
                html += '<tbody>';
                html += '<tr>';
                html += '<td>';
                html += '<p>';
                html += 'Вы выбрали <span class="department target-region">Хайнань</span> из <span class="department target-city">Алматы</span> на <span class="department target-days">8 дней</span> <span class="department target-hotel">отель 5 звезд</span> с <span class="department target-date">19.12.2013</span>';
                html += '</p>';
                html += '<div class="button-wrapper rel">';
                html += '<input required="" placeholder="email@mail.ru" style="" type="email">';
                html += '<button id="getHotTours" style="">Отправить</button>';
                html += '<div class="clearfix"></div>';
                html += '</div>';
                html += '<p class="text-center">Введите ваш e-mail и наши специалисты отправят вам лучшие предложения</p>';
                html += '</td>';
                html += '</tr>';
                html += '</tbody>';
                html += '</table>';
            }
        }

        this.element.parent().before(html);
        if (!this._options['elems'].filter) {
            this._options['elems'].filter = $('#resultsFilter');
        }
        this._options['elems'].help = $('#super_help');
        if (this.options['showForm'] === true) {
            this._options['elems'].form = $('#resultsForm');
        }

        //Вызываем заполнение данных фильтра
        this._renderFilterData();
        //this.refreshFilter();

        // генерация события renderFilter
        this._trigger("renderFilter");

        /*Сортировка элементов фильтра*/
        this._sortFilter();

        if (this.options['debug']) tmEnd('_renderFilter');
    },

    _renderPagination: function () {
        switch (this.options.paginationType) {
            case 'pagination': 		//постраничная навигация

                break;

            default: 		//кнопка смотреть еще N туров see-more-tours
                var html = "";
                var cls = (this.options.isTable ? '' : ' btn-clear');
                html = "<div class='see-more-tours'>" +
                    "<button type='button' class='h-button" + cls + "'>" +
                    (this.options.mobile ? '<i class="icon"></i> Еще' : 'Показать еще') +
                    " <span>" + this.options['baseCountView'] + " отелей</span>" +
                    "</button>" +
                    "</div>";
                if (this.options.isTable) {
                    this.element.parent().after(html);
                }
                else {
                    this.element.find('.search_content__pages').html(html)
                }

                this._options['elems'].button = this.element.find('.see-more-tours');
                break;
        }
    },

    _sortFilter: function () {
        var filters = this.options['filters'], ff_key;
        var isTable = this.options.isTable;
        for (ff_key in filters) {
            var ff = filters[ff_key];
            var $filter = $("#filterTbl_" + ff_key);
            if ($filter.length === 0) return;

            var vals = [], objs = [];
            var $values = $filter.children('.values');
            $values.find('input').each(function () {
                var v = $(this).val();
                vals.push(v);
                if ($(this).prop('checked')) $(this).attr('checked', true);
                else $(this).attr('checked', false);

                if (isTable) {
                    objs[v] = $(this).parent()[0].outerHTML;
                }
                else {
                    objs[v] = $(this).closest('.item')[0].outerHTML;
                }
            });
            switch (ff_key) {
                case "nights":
                    vals.sort(function (a, b) {
                        return a - b;
                    });
                    break;
                case "priceBound":
                    vals.sort(function (a, b) {
                        a = a.substr(4);
                        a = parseInt(a);
                        b = b.substr(4);
                        b = parseInt(b);
                        return a - b;
                    });

                    break;
                case 'class':
                    vals.sort(function (a, b) {
                        if (parseInt(a) && parseInt(b)) {
                            return b - a;
                        } else {
                            if (!parseInt(a)) {
                                return 1;
                            }
                            if (!parseInt(b)) {
                                return -1;
                            }
                        }
                        return 0;
                    });
                    break;
                case 'meal':
                case 'region':
                    vals.sort(function (a, b) {
                        if (ff['values'][a]['count'] > ff['values'][b]['count']) {
                            return -1;
                        } else if (ff['values'][a]['count'] < ff['values'][b]['count']) {
                            return 1;
                        }
                        return 0;
                    });
                    break;
                case 'date':
                    vals.sort(function (a, b) {
                        var da = moment(a, 'DD.MM').toDate();
                        var db = moment(b, 'DD.MM').toDate();
                        if (da > db) {
                            return 1;
                        } else if (db > da) {
                            return -1;
                        }
                        return 0;
                    });
                    break;
                default:
                    vals.sort();
                    break;
            }
            //$values.empty();
            var h = '', k;
            for (k in vals) {
                h += objs[vals[k]]
                //$values.append(objs[vals[k]]);
            }
            $values.html(h);
        }

    },

    //Отрисовка таблицы
    _renderTable: function () {
        // генерация события renderTable
        this._trigger("renderTable");
    },


    //Анализ таблицы и вытаскивание из нее данных для фильтра
    _analyzeTable: function () {
        if (this.options['debug']) tmSt('_analyzeTable');
        var ff, f_pos;
        var pos_arr = [];
        var filters = [], td, minBound, maxBound;
        var tableData = {};
        var $table = this.element;
        var isTable = this.options.isTable;
        var i = -1;
        //Собираем поля, по которым будем фильтровать
        if (this.options['debug']) tmSt('_analyzeTable: filterHeader');

        var $filterItems = isTable ? $table.find("thead tr.filterHeader th")
            : $table.find('.thead .ht-filter-fill-item');

        $filterItems.each(function () {
            i++;
            ff = $(this).data('filter') || "";
            if (ff == "") {
                return;
            }
            f_pos = $(this).data('filter-pos');
            var q = $(this);
            filters[ff] = [];
            filters[ff]['title'] = $(this).data('filter-title') || $(this).text();
            filters[ff]['name'] = ff;
            filters[ff]['forceUpdate'] = false;
            filters[ff]['values'] = [];
            filters[ff]['index'] = i;
            filters[ff]['pos'] = f_pos;
            filters[ff].hideOnHotelsSearch = $(this).hasClass('hide-on-hotels-search');
            pos_arr[f_pos] = [];
            pos_arr[f_pos]['f_key'] = ff;
            pos_arr[f_pos]['value'] = filters[ff];
        });

        //сортируем
        var ffilters = [];
        for (f_pos in pos_arr) {
            ffilters[pos_arr[f_pos]['f_key']] = pos_arr[f_pos]['value'];
        }
        filters = ffilters;
        if (this.options['debug']) tmEnd('_analyzeTable: filterHeader');

        //Собираем данные для фильтров
        if (!this.options['startWithEmpty']) {
            if (this.options['data'] === null) {
                if (this.options['debug']) tmSt('_analyzeTable: data from DOM');

                $table.find('tbody tr').each(function () {
                    var id = $(this).prop('id');
                    //tableData[id] = new Array();
                    if (!tableData[id]) {
                        tableData[id] = [];
                        tableData[id]['visible'] = true;
                        tableData[id]['cur_visible'] = true;
                        tableData[id]['comment'] = '';
                        tableData[id]['managersComments'] = '';
                        tableData[id]['values'] = [];
                    }
                    //debug(tableData);
                    var ff_key;
                    for (ff_key in filters) {
                        ff = filters[ff_key];
                        td = $(this).find("td:eq(" + ff['index'] + ")");
                        var f_val = td.data('val') || td.text();
                        f_val = '' + f_val;
                        if (f_val == '') return 0;

                        if (ff_key == 'priceBound') {
                            var t = new String(f_val);
                            f_val = parseInt(f_val);
                            var currency = t.slice(f_val.toString().length, t.length);

                            var t = Math.floor(f_val / 500);
                            tableData[id]['values']['price'] = f_val;
                            minBound = t * 500;
                            maxBound = (t + 1) * 500;
                            f_val = maxBound;

                            if (currency == '$') {
                                f_val = "от " + currency + minBound + " до " + currency + maxBound;
                            } else {
                                f_val = "от " + minBound + currency + " до " + maxBound + currency;
                            }
                        } else if (ff_key == 'recs') {
                            if (f_val == 0) {
                                continue;
                            } else {
                                //f_val=parseInt(f_val);
                            }
                        }

                        if (ff['values'][f_val]) {
                            ff['values'][f_val]['all_count']++;
                            ff['values'][f_val]['count']++;
                        } else {
                            ff['values'][f_val] = [];
                            ff['values'][f_val]['hidden'] = false;
                            ff['values'][f_val]['rendered'] = false;
                            ff['values'][f_val]['all_count'] = 1;
                            ff['values'][f_val]['count'] = 1;
                            ff['values'][f_val]['value'] = f_val;
                        }

                        tableData[id]['values'][ff_key] = f_val;

                    }
                });
                if (this.options['debug']) tmEnd('_analyzeTable: data from DOM');
            } else {
                if (this.options['debug']) tmSt('_analyzeTable: data from JSON');
                tableData = this.options['data'];
                var id, ff_key;
                for (id in tableData) {
                    var row = tableData[id];
                    for (ff_key in filters) {
                        ff = filters[ff_key];
                        var f_val = row['values'][ff_key];
                        f_val = '' + f_val;
                        if (f_val == '') continue;

                        if (ff_key == 'recs') {
                            if (f_val == 0) {
                                continue;
                            }
                        }

                        if (ff['values'][f_val]) {
                            ff['values'][f_val]['all_count']++;
                            ff['values'][f_val]['count']++;
                        } else {
                            ff['values'][f_val] = [];
                            ff['values'][f_val]['hidden'] = false;
                            ff['values'][f_val]['rendered'] = false;
                            ff['values'][f_val]['all_count'] = 1;
                            ff['values'][f_val]['count'] = 1;
                            ff['values'][f_val]['value'] = f_val;
                        }
                    }
                }
                if (this.options['debug']) tmEnd('_analyzeTable: data from JSON');
            }
        }


        if (this.options['debug']) tmSt('_analyzeTable: filter sort');
        //сортируем значения фильтров
        for (ff_key in filters) {
            var ff = filters[ff_key];
            if (this.options['deleteEmptyFilter'] && count(ff['values']) == 0) {
                delete(filters[ff_key]);
                continue;
            }
            if (ff_key == 'priceBound') {

            } else if (ff_key == 'date') {
                ff['values'] = ksort(ff['values'], function (a, b) {
                    var now = new Date();
                    a = a.split('.');
                    b = b.split('.');
                    //	m/d/Y
                    var ddA = new Date(a[1] + "/" + a[0] + "/" + now.getFullYear());
                    var ddB = new Date(b[1] + "/" + b[0] + "/" + now.getFullYear());
                    a = ddA.getTime();
                    b = ddB.getTime();
                    if (a > b) {
                        return 1;
                    } else if (a < b) {
                        return -1;
                    } else {
                        return 0;
                    }
                });
            } else {
                ff['values'] = ksort(ff['values']);
            }

        }
        if (this.options['debug']) tmEnd('_analyzeTable: filter sort');
        this._setOption('data', tableData);
        this._setOption('filters', filters);
        if (this.options['debug']) tmEnd('_analyzeTable');
    },

    //Анализ данных на корректность
    _analyzeData: function () {

    },

    //вешаем обработчики событий
    _handlers: function () {
        if (this.options['debug']) tmSt('_handlers');
        //Вешаем обработчик на данную кнопку
        var that = this;
        //$(".see-more-tours button")
        if (this._options.elems.button) {
            this._options.elems.button.find('button').on('click', function () {
                that._setOption('countView', (that.options['countView'] + that.options['baseCountView']));
                that._refresh();
                if (that.options['baseCountView']) {
                    stat('hotTable.moreHotelsButtonClick', {
                        info: 'page ' + Math.ceil(that.options['countView']/that.options['baseCountView']),
                    });
                }
            });
        }


        if (null != this.options.elems.pagination) {
            this.options.elems.pagination.find('ul').on('click', 'li', function () {
                if ($(this).hasClass('disabled')) return;
                var p = $(this).data('page');
                switch ($(this).data('type')) {
                    case 'start':
                        if (that.options.page == 1) return;
                        p = 1;
                        break;
                    case 'end':
                        if (that.options.page == that.options.pageCount) return;
                        p = that.options.pageCount;
                        break;
                    case 'prev':
                        if (that.options.page - 1 <= 0) return;
                        p = that.options.page - 1;
                        break;
                    case 'next':
                        if (that.options.page + 1 > that.options.pageCount) return;
                        p = that.options.page + 1;
                        break;
                    default:
                        if (p == that.options.page) return;
                        break;
                }
                if (p > 1) {
                    stat('hotTable.pageButtonClick', {
                        info: 'page ' + p
                    });
                }
                that._setOption('page', p);
                that._refresh();
                that._trigger('onPageClick');
            });
        }

        //Вешаем обработчик по нажатию на чекбокс
        var $filter = this._options['elems'].filter;

        $filter.on('click', '.filterTbl button.visible', function () {
            $(this).find('input').trigger('click');
        });

        $filter.on('click', '.filterTbl .visible input', function () {
            //console.time("filter click"); //В IE НЕ РАБОТАЕТ
            if (that.options['debug']) tmSt('filter click');

            /*Собираем чекнутые значения фильтра*/
            var params = that.options['filterCheckedParams'];
            var nm = $(this).closest('.filterTbl').data('name');

            var $button = that.options.isTable ? [] : $(this).closest('button');

            var vl = $(this).val();
            var curIndex = typeof(params[nm]) !== 'undefined' ? params[nm].indexOf(vl) : -1;
            if ($(this).is(":checked")) {
                if ($button.length) $button.addClass('checked');
                if (!params[nm]) params[nm] = [];
                if (curIndex === -1) {
                    params[nm].push(vl);
                }
            } else {
                if ($button.length) $button.removeClass('checked');
                //delete(params[nm][k]);
                if (curIndex !== -1) {
                    params[nm].splice(curIndex, 1);
                }
                if (count(params[nm]) === 0) {
                    delete params[nm];
                }
            }
            //Выбранные фильтры текстом
            that._updateFilterDesc();

            //log(params);
            if (that.options['instantFilter']) {
                that._applyFilters();
            } else if (!that.options.mobile) {
                $('.wrapper_apply_filters').show();
                if (window.adjustApplyFiltersButton) {
                    window.adjustApplyFiltersButton();
                }
            }

            //filterOnScroll();
            //console.timeEnd("filter click"); //В IE НЕ РАБОТАЕТ
            if (that.options['debug']) tmEnd('filter click');
        });

        that.element.on('click', '.reset_filters', function () {
            that._resetFilter();
        });

        if (this.options['toggleFilter']) {
            var $hf = $filter.closest('.hotFilter');
            $hf.on('click', '.hf-title', function (e) {
                e.preventDefault();
                $hf.find('.hf-body').stop().slideToggle();
                $hf.find('.hf-button-arrow').toggleClass('hf-button-arrow__down');
            })
        }

        //Закрытие всплывающей подсказки
        $('#super_help .close_super_help').on('click', function () {
            $("#super_help").hide();
        });
        //log('comment' + this.options['addComment']);
        if (this.options['addComment']) {
            //нажатие на кнопку добавления комментария
            this.element.on('click', '.addComment', function (e) {
                e.preventDefault();
                var parnt = $(this).closest('tr');
                var id = parnt.data('id');
                var vals = that.options['data']['r' + id];
                var $wrapper = $('#record_popupCommentTemplate');
                var $tplCommentText = $wrapper.find('.recordText');
                $('#Comment').val(vals.comment || '').data('id', id);
                if (vals.commentTemplate && vals.commentTemplateText) {
                    $wrapper.find('.inpRecordId').val(vals.commentTemplate);
                    $wrapper.find('.inpRecordText').val(vals.commentTemplateText);
                    $tplCommentText.html(vals.commentTemplateText.replace(/\n/g, '<br>'));
                    $wrapper.removeClass('empty');
                } else {
                    $wrapper.find('.inpRecordId').val('');
                    $wrapper.find('.inpRecordText').val('');
                    $tplCommentText.html('');
                    $wrapper.addClass('empty');
                }
                $('#myModalComment').dialog('open');
            });
        }

        this.element.on('click', '.flights-info', function (event) {
            var h_id = $(this).closest('tr').data('id'),
                mainFlights = that.options['data']['r' + h_id]['values']['flights'],
                domesticFlights = that.options['data']['r' + h_id]['values']['domesticFlights'];

            var content =
                '<table class=\"table table-hover\">' +
                '<thead>' +
                '<tr>' +
                '<th>Рейс</th>' +
                '<th>Вылет</th>' +
                '<th>Прилет</th>' +
                '</tr>' +
                '</thead>' +
                '<tbody>';

            function createRow(flight) {
                return (
                    '<tr>' +
                    '<td>' + flight.airlineName + '<br>' + flight.flight + '</td>' +
                    '<td>' +
                    flight.fromCity + ', ' + flight.from + '<br> ' +
                    flight.beautifulFromDate + ' ' + flight.departTime +
                    '</td>' +
                    '<td>' +
                    flight.toCity + ', ' + flight.to + '<br>' +
                    flight.beautifulToDate + ' ' + flight.arrivalTime +
                    '</td>' +
                    '</tr>'
                );
            }

            var mainForwardContent = '';
            var mainBackwardContent = '';
            mainFlights.forEach(function(flight) {
                var tmpContent = createRow(flight);

                if (flight.direction === 'forward') {
                    mainForwardContent += tmpContent;
                } else {
                    mainBackwardContent += tmpContent;
                }
            });

            var domesticForwardContent = '';
            var domesticBackwardContent = '';
            domesticFlights.forEach(function(flights) {
                flights.forEach(function(flight) {
                    var tmpContent = createRow(flight);

                    if (flight.direction === 'forward') {
                        domesticForwardContent += tmpContent;
                    } else {
                        domesticBackwardContent += tmpContent;
                    }
                });
            });

            content += (mainForwardContent + domesticForwardContent +
                domesticBackwardContent + mainBackwardContent + '</tbody></table>');

            popup2({
                content: content,
                width: 800
            });
        });

        //Комментарий менеджера
        this.element.on('mouseenter', '.hotel_comment', function (event) {
            $(this).qtip({
                overwrite: false, // Don't overwrite tooltips already bound
                show: {
                    event: event.type, // Use the same event type as above
                    ready: true // Show immediately - important!
                },
                style: {
                    classes: 'qtip-bootstrap',
                    width: '350px'
                },
                content: {
                    title: "Комментарий менеджера",
                    text: function (event, api) {
                        var managersComments = '';
                        var h_id = api.elements.target.closest('tr').data('id'),
                            comments = that.options['data']['r' + h_id]['managersComments']
                                || that.options['data']['r' + h_id]['values']['managersComments'];

                        if (comments !== '') {
                            comments = JSON.parse(comments);
                            for (var i in comments) {
                                var comment = comments[i];
                                var text = ftScript(comment.text + '\r\n', true);

                                if (comment.author) {
                                    managersComments += ('<strong>' + comment.author + '</strong>');
                                    managersComments += ('<br>' + text);
                                    managersComments += ('<span class="pull-right" style="margin-top: 3px"><small' +
                                        ' class="text-muted">'
                                        + comment.created_at
                                        + '</small></span><br><hr style="margin-top: 3px; margin-bottom: 10px">'
                                    );
                                } else {
                                    managersComments += (comment.text + '<hr>');
                                }
                            }
                        }

                        return managersComments;
                    }
                },
                position: {
                    my: 'bottom center',
                    at: 'top center',
                    adjust: {
                        method: 'flipinvert'
                    },
                    viewport: $(window)
                },
                hide: {
                    fixed: true,
                    delay: 300
                }
            });
        });

        //Рекомендации менеджеров - всплывашка
        this.element.on('mouseenter', '.hotelRec', function (event) {
            $(this).qtip({
                overwrite: false, // Don't overwrite tooltips already bound
                show: {
                    event: event.type, // Use the same event type as above
                    ready: true // Show immediately - important!
                },
                style: {classes: 'qtip-bootstrap'},
                content: {
                    title: "Рекомендации менеджеров",
                    text: function (event, api) {
                        var h_id = api.elements.target.data('hotel');
                        var url = '/tours/default/recs?hotel_id=' + $(this).data('hotel');
                        var response = img_load;

                        if (that.options['hotelRecs'][h_id]) {
                            //log('from cache');
                            response = that.options['hotelRecs'][h_id];
                        } else {
                            //log('from ajax');
                            $.ajax({
                                url: url,
                                dataType: 'json'
                            })
                                .then(function (data) {
                                    // Set the tooltip content upon successful retrieval
                                    var html = "<p class='hotel_recs_avatars'>";
                                    for (k in data.managers) {
                                        t = data.managers[k];
                                        html += "<img class='hotelRec_avatar' src='/fls/avatar/" + t['avatar'] + "' title='" + t['name'] + "' />";
                                    }
                                    html += "</p>";
                                    that.options['hotelRecs'][h_id] = html;
                                    api.set('content.text', html);
                                }, function (xhr, status, error) {
                                    // Upon failure... set the tooltip content to error
                                    api.set('content.text', "Ошибка");
                                });
                        }
                        return response;
                    }
                },
                position: {
                    my: 'bottom center',
                    at: 'top center',
                    container: $('.hotTips'),
                    adjust: {
                        method: 'flipinvert'
                    },
                    viewport: $(window)
                },
                hide: {
                    fixed: true,
                    delay: 300
                }
            });
        });
        $("div.hotTips").on('mouseenter', '.hotelRec_avatar', function (event) {
            $(this).qtip({
                overwrite: false, // Don't overwrite tooltips already bound
                show: {
                    event: event.type, // Use the same event type as above
                    ready: true // Show immediately - important!
                },
                style: {classes: 'qtip-bootstrap'},
                position: {
                    my: 'bottom center',
                    at: 'top center'
                }
            });
        });

        //клик на количество более дешевых отелей
        if (this.options['checkCheap']) {
            this.element.on('click', '.cheap_place', function (event) {
                var data = that.options['data'], t = $(this), tr = t.closest('tr');
                var row_id = $(this).closest('tr').prop('id');
                var tbody = '', row;
                if (data[row_id]['cheapList'].length > 0) {
                    for (var k in data[row_id]['cheapList']) {
                        row = that.getCheapRow(data[data[row_id]['cheapList'][k]]);
                        tbody += row;
                    }
                }
                var content = that.options.templates.hotels.main;
                content = content.split(that.options.b.start + 'hotel_name' + that.options.b.end).join(tr.find('.hotel_name p').text() + ' - более дешевые варианты');
                content = content.split(that.options.b.start + 'tbody' + that.options.b.end).join(tbody);

                popup2({
                    content: content,
                    width: 800
                });
            });

            window.findHotel = function (hotel_id, options) {
                options = options || {};
                var findType = options.hasOwnProperty('findType') ? options['findType'] : 1;
                hotel_id = Number(hotel_id);
                var elems = $('tr[data-hotel-id=' + hotel_id + ']', '#results');
                var items = elems.find('.findHotel'), visited = items.first().hasClass('visited');
                items.addClass('visited');
                elems.addClass('checked-hotel');
                if (!that.options['showPrices']) {
                    elems.find('.loupeWrapper').addClass('hidden');
                    elems.find('.priceWrapper').removeClass('hidden');
                }
                if (!visited) {
                    var data = resultTable.hotTable('option', 'data'),
                        new_dates = {},
                        new_nights = {};
                    //расширяем диапазоны дат и ночей поиска, чтобы в него попали даты,
                    //на которые есть более выгодные предложения
                    for (var row_id in data) {
                        if (data[row_id]['values']['hotel_id'] == hotel_id) {
                            if (typeof data[row_id]['values']['priceInfo'] == 'object' &&
                                data[row_id]['values']['priceInfo'].hasOwnProperty('cheap')) {
                                new_dates[data[row_id]['values']['priceInfo']['cheap']['date']] = 1;
                                new_nights[data[row_id]['values']['priceInfo']['cheap']['nights']] = 1;
                            }
                        }
                    }
                    stat(15, {hotel_id: hotel_id});
                    that.popupPricesHotelIds.push(hotel_id);
                    findTours({
                        addToPrev: true,
                        add_dates: Object.keys(new_dates),
                        add_nights: Object.keys(new_nights),
                        pages: 1,
                        params: {anyHotel: 0, hotels: [hotel_id]},
                        findType: findType,
                        callback: options.callback || options.onChunk,
                        onEnd: options.onEnd
                    });
                    that._trigger('onCheckHotel', {
                        hotel_id: hotel_id,
                        hotel_ids: that.popupPricesHotelIds,
                    });
                    return true;
                }
                return false;
            };

            window.updateSelectedTours = function () {
                //собираем id выбранных
                var selected = [], sameHotels = {};
                var data = resultTable.hotTable('option', 'data'),
                    group_key;
                for (var row_id in data) {
                    if (data[row_id]['selected']) {
                        selected.push(row_id);
                    }
                    group_key = resultTable.hotTable('get_group_key', row_id);
                    if (!sameHotels.hasOwnProperty(group_key)) {
                        sameHotels[group_key] = [];
                    }
                    sameHotels[group_key].push(row_id);
                }
                var changeList = {};
                selected.forEach(function (s_row_id) {
                    var s_row = data[s_row_id]['values'];
                    var group_key = resultTable.hotTable('get_group_key', s_row_id);
                    if (sameHotels.hasOwnProperty(group_key)) {
                        sameHotels[group_key].forEach(function (h_row_id) {
                            var same_row = data[h_row_id]['values'];
                            if (same_row['meal'] == s_row['meal']
                                && same_row['nights'] == s_row['nights']
                                && same_row['price'] < s_row['price']
                                && (!changeList.hasOwnProperty(s_row['id']) || same_row['price'] < changeList[s_row['id']]['price'])) {
                                changeList[s_row['id']] = {
                                    new_id: same_row['id'],
                                    price: same_row['price']
                                };
                            }
                        });
                    }
                });
                for (var s_row_id in changeList) {
                    window.hotTableSelectRow(s_row_id, '', false);
                    window.hotTableSelectRow(changeList[s_row_id]['new_id'], '', true);
                }
                //window.resultTable.hotTable('option', 'data', data);
                //window.hotTableData = data;
                //cl(changeList);
            };

            this.element.on('click', '.findHotel', function () {
                var hotel_id = Number($(this).closest('tr').data('hotel-id'));
                findHotel(hotel_id, {
                    callback: function (searchReq) {
                        //сбрасываем туры на страницу
                        if (searchReq.isEnd && window.hasOwnProperty('showTours')) {
                            window.showTours();
                        }
                        var el = $('tr[data-hotel-id=' + hotel_id + ']:visible', '#results');
                        if (el && el.length) {
                            //если пришли данные и тур не в зоне видимости
                            /*
                            vat tours = searchReq.lastChunkTours.getAll();
                             if ((tours.length || searchReq.isEnd) && !checkVisible(el)) {
                             moveToElement(el, 70);
                             }
                             */
                            // scrollToElement(el, 70);
                            /*
                             var id = el.data('id');
                             var $mh = $("#mh"+id);
                             if($mh.length && !$mh.hasClass('more-hotels-open')){
                             $mh.trigger('click');
                             }
                             */
                        }
                        //$("#results").hotTable('popupPrices', hotel_id, 'update');
                    }
                });
                //that.popupPrices(hotel_id);
            });

            $("#bspopup").on('click', '.cheap_hotels_go', function (event) {
                close_popup();
            });

            if (this.options['selectable']) {
                $("#bspopup").on('click', '.cheap_hotels_select', function (event) {
                    var row_id = $(this).data('id');
                    that.renderItems({items: [row_id]});
                    $(this).closest('tr').toggleClass('selected');
                    window.hotTableSelectRow(row_id);
                });
            }

        }

        if (this.options['group']) {
            this.element.find('.more_hotels_mpopup').on('hidden.mpopup', function () {
                that.closeSameHotels($(this).data('id'));
                $('#r' + $(this).data('id')).find('.more-hotels-open').removeClass('more-hotels-open');
            });
            this.element.on('click', '.more-hotels', function (e) {
                var $self = $(this);
                if (that.options.findSameTours) {
                    // да! мне стыдно за этот код...
                    var $btn = $('<span class="showHotelInfo" data-target-tab="tabSame"></span>');
                    $self.after($btn);
                    $btn.click().remove();
                    return false;
                }
                if (that.options['moreHotelsPlace'] === 'mpopup') {
                    var mainId = $self.data('mainId');
                    that.showSameHotels(mainId);
                } else {
                    var mainId = $self.data('mainId');
                    if (!mainId) {
                        var closestTr = $self.closest('tr'),
                            d = closestTr.data();
                        mainId = d.id;
                    }
                    if ($self.hasClass('more-hotels-open')) {
                        $self.html($self.data('text'));
                        $self.removeClass('more-hotels-open');
                        that.closeSameHotels(mainId);
                    } else {
                        that.showSameHotels(mainId);
                        $self.data('text', $self.html());
                        $self.html('<span>Скрыть</span>');
                        $self.addClass('more-hotels-open');
                    }
                }
            });
        }

        if (!this.options['instantFilter']) {
            if (this.options.mobile) {
                $('.select_filters').click(function(){
                    that._applyFilters();
                });
            } else {
                var $wrapperApplyFilters = $('.wrapper_apply_filters');
                var $parentWrapperApplyFilters = $wrapperApplyFilters.parent();
                var $btnApplyFilters = $('.btn_apply_filters');
                window.adjustApplyFiltersButton = window.utils.throttle(function() {
                    if (!$wrapperApplyFilters.length) {
                        return false;
                    }
                    var elBottom = $wrapperApplyFilters.offset().top + $wrapperApplyFilters.height();
                    var scrollBottom =
                        document.documentElement.clientHeight + document.documentElement.scrollTop;
                    if (scrollBottom < elBottom) {
                        $btnApplyFilters.addClass('fixed');
                        var diff = $parentWrapperApplyFilters.offset().top + 150 - scrollBottom;
                        $btnApplyFilters.css('bottom', diff > 0 ? -diff + 'px' : 0);
                    } else {
                        $btnApplyFilters.removeClass('fixed');
                    }
                }, 150);
                $btnApplyFilters.click(function() {
                    $wrapperApplyFilters.hide();
                    that._applyFilters();
                });
                $(window).on('scroll resize', adjustApplyFiltersButton)
            }
        }

        $('.btn-toggle-map').click(function() {
            var mapTab = $('#toursTabs .show-map-tab');
            if (!mapTab.hasClass('active')) {
                mapTab.find('a').click();
                $(this).text('Закрыть карту');
            } else {
                $('#toursTabs .show-tours-tab a').click();
                $(this).text('Показать на карте');
            }
        });

        $(window).on('search.startMain', function() {
            $('.wrapper_apply_filters').hide();
            that.foundFilterParams = [];
        });

        /**
         * Так как мы выводим только 1 плашку отеля, то при нажатии на искать цену, он проверяем цену на весь
         * выбранный клиентов диапазон, а только проверяет цену на дату самого дешевого туров
         * Это неправильно, поэтому вместо показа стоимости открывается всплывашка отеля с поиском на весь период,
         * указанный клиентом в параметрах поиска
        this.element.on('click', '.btn-find-best-price', function() {
            var $self = $(this);
            var $row = $self.closest(!that.options.isTable ? '.js_tour_item' : 'tr');
            if (that.options.mobile) {
                $row.find('.hotel_price_old,.main_price_wrap').show();
            } else {
                $row.find('.hotel_price_old,.hotel_price,.btn-price-for-one,.price-for-tour-wrapper')
                    .show();

            }
            $self.remove();
            that.showTourCheapestPrice($row, true);
            stat('hotTable.searchPriceButtonInTourRowClick');
        });
         */

        $('#onlyFavoriteHotels').on('change', function () {
            that.options.onlyFavHotels = $(this).prop('checked');
            if (that.options.onlyFavHotels) stat(6);
            that.refreshWidget();
        });

        $('#isBestPrice').on('change', function () {
            that.options.onlyBestPrice = $(this).prop('checked');
            if (that.options.onlyBestPrice) stat(5);
            that.refreshWidget();
        });

        $('#onlyMomentConfirm').on('change', function () {
            that.options.onlyMomentConfirm = $(this).prop('checked');
            //if (that.options.onlyFavHotels) stat(6);
            that.refreshWidget();
        });

        $('#onlyGuaranteeConfirm').on('change', function () {
            that.options.onlyGuaranteeConfirm = $(this).prop('checked');
            //if (that.options.onlyFavHotels) stat(6);
            that.refreshWidget();
        });


        // $('.search_content__map .close_mpopup_custom').on('click', function(){
        //    $('.toggle_ht_mode').trigger('click');
        // });

        // trigger
        // $('.toggle_ht_mode').on('click', function(){
        // 	var $self = $(this);
        //  that._changeMode($self);
        // });

        $('.hot-table-tab').on('click', function () {
            that._changeMode();
        });

        if (!this.options['isTable'] && this.options['refreshFilterDesc']
            && this.options['moreHotelsPlace'] === 'mpopup') {
            var $filter_headers = $('.filter_headers');
            var $filter_values = $('.filter_values');
            var $filter_header_items = $filter_headers.find('.ht-filter-items .hint');
            $('.ht-filter-items .item button').on('click', function () {
                var allowed_filter_types = ['class', 'meal', 'region', 'nights', 'priceBound', 'date'];
                var filter_type = $(this).parent().data('filter');

                $filter_values.find('.filterTbl').removeClass('visible');
                $filter_values.find('#filterTbl_' + filter_type).addClass('visible');

                open_popup({
                    target: '.filter_values',
                    title: $(this).data('title'),
                    footer: 1,
                    header: 1,
                });
            });

            $filter_headers.on('hidden.mpopup', function () {
                var isNeedScrollTop = parseInt($filter_headers.data('scroll-top'));
                if (isNeedScrollTop === 1) {
                    scrollToElement(that.element);
                }
                $filter_headers.data('scroll-top', 0);
            });

            $filter_values.on('hidden.mpopup', function () {
                var countChangedFilters = 0;
                $filter_header_items.each(function (index) {
                    if ($(this).data('highlight') == 1) {
                        countChangedFilters++;
                        $(this).addClass('blink_text').data('highlight', 0);
                    }
                });
                $filter_headers.data('scroll-top', (countChangedFilters > 0 ? 1 : 0));
                setTimeout(function () {
                    $filter_header_items.removeClass('blink_text');
                }, 1500);
            });

        }


        if (this.options.sortable) {
            if (this.options.sortParams.sortFilterParentSelector === '') {
                //рисуем селект
                var h = '', sl, k;
                h += '<label for="#hotTableSortable">Сортировать по: <select id="hotTableSortable">';
                for (k in this.options.sortFilters) {
                    sl = (k == this.options.sortBy) ? ' selected="selected"' : '';
                    h += '<option' + sl + ' value="' + k + '">' + this.options.sortFilters[k].name + '</option>';
                }
                h += '</select></label>';
                $("#managerFilters").append(h);
                //изменение селекта
                $("#hotTableSortable").on('change', function () {
                    that._makeResort($(this).val());
                });
            } else {
                var $parent = $(this.options.sortParams.sortFilterParentSelector);
                this.renderSortButtons($parent);
                var sortPriceButtonClicked = false;
                var sortPopularityButtonClicked = false;
                var onlyPremiumHotelsClicked = false;
                $parent.on('click', '.ht-sort-item', function() {
                    var $self = $(this);
                    var sortByField = $self.data('field');
                    switch (sortByField) {
                        case 'price':
                            if (!sortPriceButtonClicked) {
                                sortPriceButtonClicked = true;
                                stat('hotTable.priceSortButtonClick');
                            }
                            break;
                        case 'popularity':
                            if (!sortPopularityButtonClicked) {
                                sortPopularityButtonClicked = true;
                                stat('hotTable.popularitySortButtonClick');
                            }
                            break;
                    }
                    var sortDirection = that._getSortDirection(sortByField).toLowerCase();
                    if (!$self.hasClass('active')) {
                        $parent.find('.ht-sort-item').removeClass('active');
                        $self.addClass('active');
                    } else {
                        if (sortDirection === 'asc') {
                            sortDirection = 'desc';
                        } else {
                            sortDirection = 'asc';
                        }
                    }
                    var result = that._makeResort(sortByField, sortDirection);
                    var title;
                    if (result) {
                        title = that._getSortFieldLabel(sortByField);
                        $self.find('.ht_label').html(title);
                        $self.find('.icon')
                            .removeClass('asc desc')
                            .addClass(sortDirection);
                    }
                })
                    .on('change', '.ht_checkbox input', function() {
                        // onlyPremium ...
                        var $self = $(this);
                        var isChecked = $self.is(':checked');
                        $self.parent().toggleClass('checked');
                        var propertyName = $self.prop('name');
                        if (that.options.hasOwnProperty(propertyName)) {
                            if (propertyName === 'onlyPremium' && !onlyPremiumHotelsClicked) {
                                onlyPremiumHotelsClicked = true;
                                stat('hotTable.onlyPremiumHotelsButtonClick');
                            }
                            that.options[propertyName] = isChecked;
                            that.refreshWidget();
                            that._trigger('onClientRefreshWidget', null, {
                                filterField: propertyName,
                                isChecked: isChecked,
                            });
                        } else {
                            console.warn('unknown property name');
                        }
                    });
            }
        }

        $('body').tooltip({
            selector: '[data-toggle="tooltip"]'
            //container: 'body'
        });

        if (this.options['debug']) tmEnd('_handlers');
    },

    _getSortDirection: function(field) {
        var result = '';
        if (!this.options.sortFilters.hasOwnProperty(field)) {
            console.warn('unknown sort field: ' + field);
        } else {
            result = this.options.sortFilters[field].direct;
        }

        return result;
    },

    _getSortButtonForMobile: function(params) {
        return '<button type="button"' +
            ' class="btn-clear ht-sort-item' + (params.active ? ' active' : '') + '"' +
            ' data-field="' + params.sortField + '">' +
            '<span class="icon ' + params.sortType.toLocaleLowerCase() + '"></span>' +
            '<span class="title ht_label">' + params.title + '</span>' +
            '</button>';
    },

    _getSortButton: function (params) {
        return '<button type="button"' +
            ' class="btn-clear ht-sort-item' + ( params.active ? ' active' : '') + '"' +
            ' data-field="' + params.sortField + '">' +
            '<span class="title ht_label">' + params.title + '</span>' +
            '<span class="icon ' + params.sortType.toLocaleLowerCase() + '"></span>' +
            '</button>';
    },

    _getCustomFilterCheckBox: function (params) {
        var wrapCssClass = this.options.mobile ? ' pseudo-link' : '';
        var labelFWCssClass = this.options.mobile ? ' fw-m' : ' fw-n';
        return '<div class="ht_checkbox' + wrapCssClass + (params.checked ? ' checked' : '') +  '">' +
            (this.options.mobile ? '<span class="icon desc"></span>' : '') +
            '<input type="checkbox" name="' + params.field +'" ' +
            (params.checked ? '  checked="checked"' : '') + '>' +
            '<label class="ht_label ' + labelFWCssClass + '">' +
            params.title +
            '</label>' +
            '</div>';
    },

    _getDefaultSortLabels: function() {
        var result = {};
        if (this.options.mobile) {
            result = {
                popularity: {
                    name: 'Популярность',
                    ascName: 'Сначала<br>непопулярные',
                    descName: 'Сначала<br>популярные',
                },
                price: {
                    name: 'Цена',
                    ascName: 'Сначала<br>дешевле',
                    descName: 'Сначала<br>дороже',
                },
            };
        } else {
            result = {
                price: {
                    name: 'Цена',
                    ascName: 'От дешевых к дорогим',
                    descName: 'От дорогих к дешевым',
                },
                popularity: {
                    name: 'По популярности',
                }
            };
        }

        return result;
    },

    _getSortFieldLabel: function(field) {
        var fieldTitle = '';
        if (!this.options.sortFilters.hasOwnProperty(field)) {
            console.warn('unknown sort field: ' + field);
        } else {
            var item = this.options.sortFilters[field];
            var direction = item.direct.toLocaleLowerCase();
            var labelParam = direction === 'asc' ? 'ascName' : 'descName';
            var defaultLabels = this._getDefaultSortLabels();
            if (item.hasOwnProperty(labelParam)) {
                fieldTitle = item[labelParam];
            } else {
                var defaultItemLabel = defaultLabels.hasOwnProperty(field) ? defaultLabels[field] : {};
                fieldTitle = defaultItemLabel.hasOwnProperty(labelParam) ? defaultItemLabel[labelParam] : item.name;
            }
        }
        return fieldTitle;
    },

    renderSortButtons: function($parent) {
        var field,
            item,
            html = '';
        for (field in this.options.sortFilters) {
            item = this.options.sortFilters[field];
            if (this.options.mobile) {
                html += this._getSortButtonForMobile({
                    title: this._getSortFieldLabel(field),
                    sortField: field,
                    sortType: item.direct,
                    active: field === this.options.sortBy ? 'active' : '',
                });
            } else {
                html += this._getSortButton({
                    title: this._getSortFieldLabel(field),
                    sortField: field,
                    sortType: item.direct,
                    active: field === this.options.sortBy ? 'active' : '',
                });
            }

        }

        var premiumTitle = this.options.mobile ? 'VIP<br>отели' : 'Только премиум отели';
        html += this._getCustomFilterCheckBox({
            title: premiumTitle,
            checked: false,
            field: 'onlyPremium',
        });
        $parent.html(html);
    },

    _makeResort: function(sortByField, sortDirection) {
        if (this.options['debug']) tmSt('hotTableSortableChange');
        if (!this.options.sortFilters.hasOwnProperty(sortByField)) {
            console.warn('unknoun sort field');
            return false;
        }
        this._trigger('onBeforeResort', null, {
            sortByField: sortByField,
        });
        this.options.sortBy = sortByField;
        if (typeof sortDirection !== 'undefined') {
            // TODO:
            sortDirection = sortDirection.toUpperCase();
            this.options.sortFilters[sortByField].direct = sortDirection;
        }
        if (this.options.sortBy === 'priceLogSum') {
            stat(7);
        }
        //удалить из DOM
        this.removeAllRowsFromDOM();
        //пересортировать
        this.resort();
        //обновить
        this._refresh();
        if (this.options['debug']) tmEnd('hotTableSortableChange');
        this._trigger("onAfterResort");

        return true;
    },


    refreshWidget: function() {
        this._trigger("onBeforeFilter");
        var filters = this._calcFilters();
        this._setOption('filters', filters);
        this._checkVisible();
        this.refreshFilter();
        this._refresh();
    },

    //пересчет фильтров
    _calcFilters: function (params) {
        if (this.options['debug']) tmSt('_calcFilters');
        var filters = this.options['filters'],
            tableData = this.options['data'], ff_val;
        if ('function' === typeof(this.options.calcFilters)) {
            return this.options.calcFilters(tableData, filters, params);
        }

        var dd, ff, ff_key, row_id;
        //Обнуляем значения фильтра - подготовка к пересчету
        for (ff_key in filters) {
            ff = filters[ff_key];
            for (ff_val in ff['values']) {
                ff['values'][ff_val]['count'] = 0;
            }
        }
        var showHotels = {}, sameHotels = {}, k, row, add, f2, group_key;
        for (row_id in tableData) {
            dd = tableData[row_id]['values'];
            group_key = this.get_group_key(row_id);
            f2 = true;
            if (this.options['group']) {
                if (!showHotels.hasOwnProperty(group_key)) {
                    showHotels[group_key] = 1;
                    sameHotels[group_key] = [dd['id']];
                    f2 = true;
                } else {
                    add = true;
                    //пробегаем по уже добавленным и проверяем можно ли добавить новый элемент
                    //если в списке уже есть запись с таким или большим кол-вом дней, одинаковым питанием, но меньшей ценой, то не добавляем
                    if (this.options.groupOnlyBest)
                        for (k in sameHotels[group_key]) {
                            row = tableData['r' + sameHotels[group_key][k]]['values'];
                            if (parseInt(row['nights']) >= parseInt(dd['nights']) && row['meal'] == dd['meal'] && parseInt(row['price']) <= parseInt(dd['price'])) {
                                add = false;
                                f2 = false;
                            }
                        }
                    if (add) {
                        sameHotels[group_key].push(dd['id']);
                    }
                }
            }
            if (f2)
                for (ff_key in filters) {
                    ff = filters[ff_key];
                    var f = true;
                    if (this.options.onlyBestPrice && !dd['isBestPrice']) f = false;
                    if (this.options.onlyFavHotels && !dd['isFavoriteHotel']) f = false;
                    if (this.options.onlyPremium && parseInt(dd['category'], 10) !== 2) f = false;
                    if (this.options.onlyMomentConfirm && !dd['moment_confirm']) f = false;
                    if (this.options.onlyGuaranteeConfirm && !dd['guarantee_confirm']) f = false;
                    if (this.options.onlyCheckedHotels &&
                        this.popupPricesHotelIds.indexOf(parseInt(dd.hotel_id, 10)) === -1) {
                        f = false;
                    }
                    if (this.options.mode == 'map' && (!dd['coords'] || !dd['coords'][0] || !dd['coords'][1])) f = false;
                    for (var name in params) {
                        if (name == ff_key) continue;
                        if ($.inArray(dd[name], params[name]) == -1) f = false;
                    }
                    if (f) {
                        var f_val = dd[ff_key];
                        if (ff['values'][f_val]) {
                            ff['values'][f_val]['count']++;
                        }
                    }
                }
        }
        if (this.options['debug']) tmEnd('_calcFilters');
        return filters;
    },
    _applyFilters: function() {
        var params = $.extend(true, {}, this.options['filterCheckedParams']);
        this._setOption('filterParams', params);
        this._trigger("onBeforeFilter");
        //Проверяем какие строки надо показать
        this._checkVisible();
        //Показываем/скрываем строки в талице
        this._refresh();

        //Пересчитываем кол-во значений фильтра
        var filters = this._calcFilters(params);

        //обновляем фильтры
        this.refreshFilter();
        //Обновляем значения фильтра
        this._setOption('filters', filters);

        if (this.options['findMoreOnFilter']) {
            this._searchByFilters(params);
        }

        this._trigger("onAfterFilter");

    },
    // делает дополнительный поиск при переключении фильтров
    foundFilterParams: [],
    _searchByFilters: function(params) {
        var checked = {
            regions: [false],
            stars: [false],
            nights: [false],
        };
        var that = this;
        var runFinds = function() {
            var hasChecked = false;
            for (var key in checked) {
                // если выбрали хоть один фильтр, то удаляем запрос без фильтров
                if (checked[key].length > 1) {
                    checked[key].shift();
                    hasChecked = true;
                }
            }

            if (!hasChecked) {
                return false;
            }
            var findKey;
            var allowByRegion = window.lastBaseSearchParams && !lastBaseSearchParams.region;
            var allowByStars = window.lastBaseSearchParams && !lastBaseSearchParams.stars;
            if (!allowByRegion) {
                checked.regions = [false];
            }
            if (!allowByStars) {
                checked.stars = [false];
            }
            for (var i in checked.regions) {
                for (var j in checked.stars) {
                    for (var k in checked.nights) {
                        findKey = checked.regions[i] + ';' + checked.stars[j] + ';' + checked.nights[k];
                        // не ищем 2 раза по одним и тем же параметрам
                        if (that.foundFilterParams.indexOf(findKey) !== -1) {
                            continue;
                        }
                        that.foundFilterParams.push(findKey);
                        var params = {};
                        if (allowByRegion) {
                            params.region = checked.regions[i];
                        }
                        if (allowByStars) {
                            params.stars = checked.stars[j];
                        }
                        if (checked.nights[k]) {
                            params.nightsFrom = checked.nights[k];
                            params.nightsTo = checked.nights[k];
                        }
                        if (count(params) &&
                            (params.region || params.stars || params.nightsFrom)
                        ) {
                            findTours(
                                {
                                    addToPrev: true,
                                    params: params,
                                }
                            );
                        }
                    }
                }
            }
        };

        if (params.class) {
            var starNum;
            for(var i in params.class) {
                starNum = Number(params.class[i]);
                if (!isNaN(starNum)) {
                    checked.stars.push(starNum);
                }
            }
        }

        if (params.nights) {
            for (var i in params.nights) {
                checked.nights.push(Number(params.nights[i]) - 1);
            }
        }

        if (params.region) {
            rt.go('app.getRegionsIdByName', params.region, function(data) {
                for(var name in data) {
                    if (data.hasOwnProperty(name) && !isNaN(data[name]) && data[name]) {
                        checked.regions.push(data[name]);
                    }
                }
                runFinds();
            })
        } else {
            runFinds();
        }
    },
    findCheapestTour: function(tourId, callback) {
        var isSplitRoomsSearch = this.isSplitRoomsSearch();
        var tour = (window.hasOwnProperty('hotTableData') &&
            window.hotTableData.hasOwnProperty(tourId) &&
            window.hotTableData[tourId].values) || {};
        var nights = tour.nights - 1;
        findTours(
            {
                addToPrev: true,
                findType: 3,
                params: {
                    region: '',
                    stars: '',
                    anyHotel: 0,
                    nightsFrom: nights,
                    nightsTo: nights,
                    hotels: [Number(tour.hotel_id)],
                    combined: Number(tour.is_combined) === 1 ? 1 : 2
                },
                pages: 1,
                saveTours: true,
                silent: true,
                cache: true,
                onEnd: function (searchReq) {
                    var cheapestTour = searchReq.tours.getOne({ where: { 'meal': tour.meal } });
                    tour.cheapestTour = tour.isFake && isSplitRoomsSearch
                    || cheapestTour && cheapestTour.price < tour.price ? cheapestTour : false;
                    // сохраним reqHash поиска которым проверили этот отель
                    // кейс: в поиске проживания для клиентов при открытии модалки отеля
                    // там показываются все варианты, так вот варианты раньше брались из
                    // window.hotTableData, но туда не закидывались туры с поиска проверки цены
                    // и там могло оказаться не все, поэтому будем запоминать откуда тащить нам туры
                    if (tour.hotel_id) {
                        if (!window.hotelPriceCheckRequestHashList) {
                            window.hotelPriceCheckRequestHashList = {};
                        }
                        window.hotelPriceCheckRequestHashList[tour.hotel_id] = searchReq.info.reqHash;
                    }
                    callback(tour.cheapestTour);
                }
            }
        );
    },
    showTourCheapestPrice: function($el, searchTour, rowType) {
        var isSplitRoomsSearch = this.isSplitRoomsSearch();
        $el.addClass('lazy_price_loading').removeClass('lazy_price_wrap');
        var self = this;
        var tourId = 'r' + $el.data('id');
        var tour = (window.hasOwnProperty('hotTableData') &&
            window.hotTableData.hasOwnProperty(tourId) &&
            window.hotTableData[tourId].values) || {};
        var showPrice = function() {
            $el.removeClass('lazy_price_loading lazy_price_wrap');
            $el.addClass('price-calculated');
            if (tour.showDiscount
            // window.hotTableData[tourId].values.discount > 35
            ) {
                $el.removeClass('hide_discount');
            }
            tour.priceCalculated = true;
        };
        var showPriceNotFoundAlert = function () {
            $el.removeClass('lazy_price_loading lazy_price_wrap');
            $el.addClass('split-rooms-variant-not-found');
            tour.priceCalculated = true;
        };

        if (searchTour && window.findTours) {
            this.findCheapestTour(
                tourId,
                function(t) {
                    if (t) {
                        tour.priceCalculated = true;
                        $el.after(self.createRowHtml(tour, rowType));
                        $el.remove();
                        self._refresh();
                    } else if (isSplitRoomsSearch) {
                        showPriceNotFoundAlert();
                    } else {
                        showPrice();
                    }
                }
            );
        } else {
            if (this.options.lazyPrices) {
                setTimeout(showPrice, 1500);
            } else {
                showPrice();
            }
        }
    },
    updateElementsInViewport: function(selector, childSelector) {
        var $elems = $(selector);
        var elemsCnt = $elems.length;
        var autoCheck = this.options.autoCheckHotelPrice;
        if (elemsCnt) {
            var i, $elem;
            var visibleElems = [];
            var $searchElem;
            $elems.each(function() {
                $elem = $(this);
                $searchElem = $elem.find(childSelector);
                if ($searchElem.length && !$elem.hasClass('far-result') &&
                    window.utils.isElementInViewport($searchElem)
                ) {
                    visibleElems.push($elem);
                }
            });

            if (visibleElems.length) {
                for (i in visibleElems) {
                    $elem = visibleElems[i];
                    this.showTourCheapestPrice($elem, autoCheck);
                }
            }
        }
    },

    //показать все цены отеля в таблице
    popupPricesHotelId: '',
    popupPricesHotelIds: [],
    popupPrices: function (hotel_id, action) {
        action = typeof(action) != 'undefined' ? action : 'create';
        var content = this.options.templates.hotels.main, tbody = '', d, hotelName, hotelsCount = 0;
        if (!hotel_id) hotel_id = this.popupPricesHotelId;
        hotel_id = '' + hotel_id;
        this.popupPricesHotelId = hotel_id;
        for (var i in this.options['data']) {
            d = this.options['data'][i];
            if (d['values'].hotel_id == hotel_id) {
                tbody += this.getCheapRow(d);
                hotelsCount++;
                if (!hotelName) hotelName = d['values']['hotel'];
            }
        }
        content = content.split(this.options.b.start + 'hotel_name' + this.options.b.end).join(hotelName + '(' + hotelsCount + ') - поиск по отелю' + (search.isRun ? ' <span class="find_active">' + img_load + '</span>' : ''));
        content = content.split(this.options.b.start + 'tbody' + this.options.b.end).join(tbody);
        content = content.split(this.options.b.start + 'hotel_id' + this.options.b.end).join(hotel_id);
        switch (action) {
            case 'update':
                if ($("#cheap_hotels_list_" + hotel_id).length) {
                    $('.modal-body', '#bspopup').html(content);
                }
                break;
            default:
                popup2({
                    content: content,
                    width: 800
                });
                break;
        }

    },

    getPopupPricesHotelIds: function () {
        return this.popupPricesHotelIds;
    },

    showSameHotels: function (c_row_id) {
        c_row_id = 'r' + c_row_id;
        var tableData = this.options['data'];
        if (!tableData.hasOwnProperty(c_row_id)) {
            return;
        }
        var group_key = this.get_group_key(c_row_id);
        var self = this;
        var getSameHotelsFromHotTable = function() {
            var row_id, dd, sameHotels = [c_row_id], k, f, row;
            var current_group_key;
            for (row_id in tableData) {
                if (row_id == c_row_id) continue;
                dd = tableData[row_id];
                current_group_key = self.get_group_key(row_id);
                if (dd['visible'] && current_group_key == group_key) {
                    f = true;
                    //пробегаем по уже добавленным и проверяем можно ли добавить новый элемент
                    //если в списке уже есть запись с таким или большим кол-вом дней, одинаковым питанием, но меньшей ценой, то не добавляем
                    if (self.options.groupOnlyBest)
                        for (k in sameHotels) {
                            row = tableData[sameHotels[k]]['values'];
                            if (parseInt(row['nights']) >= parseInt(dd['values']['nights'])
                                && row['meal'] == dd['values']['meal']
                                && parseInt(row['price']) <= parseInt(dd['values']['price'])) {
                                f = false;
                            }
                        }
                    if (f) sameHotels.push(row_id);
                }
            }

            var sameHtml = '';
            sameHotels.shift();
            var existRows = [];	//список записей уже отрисованных - их надо удалить из DOM чтобы не было повторяющихся id в DOM
            if (sameHotels.length) {
                /*if(typeof self.options['templates']['same_labels'] !== 'undefined') {
                 sameHtml += self.createRowHtml([], 'same_labels', c_row_id);
                 }*/
                for (k in sameHotels) {
                    row = tableData[sameHotels[k]];
                    if (row['rendered']) {
                        existRows.push(sameHotels[k]);
                    }
                    sameHtml += self.createRowHtml(row['values'], 'same', c_row_id);
                }
            }
            if (existRows.length) {
                self.removeRowsFromDOM(existRows);
            }
            return sameHtml;
        };

        if (this.options['moreHotelsPlace'] === 'mpopup') {
            var mpopupSelector = '.more_hotels_mpopup';
            var tour = tableData[c_row_id]['values'];
            if (!this.options.openedHotels[group_key]) {
                var mainHotelHtml = this.createRowHtml(tour, 'mpopup_face');
                $(mpopupSelector).data('id', c_row_id.slice(1));
                var $faceItem = $(mainHotelHtml.replace('more-hotels', 'hide'));
                var $loader = $('<div class="hotels-find-wrapper">' + img_load + ' Ищем туры в отель...</div>');
                var $popupContent = $('<div>').append($faceItem).append($loader);
                showMoreHotelsMPopup({
                    target: mpopupSelector,
                    title: tour['hotel'],
                    content: $popupContent,
                });
                this.showTourCheapestPrice($('#' + c_row_id), true);
                this.showTourCheapestPrice($faceItem, true, 'mpopup_face');
            }
            if (this.options.findSameTours) {
                findSameTours(
                    {
                        tour: tour,
                        onEnd: function (searchReq) {
                            var tours = searchReq.tours.getUnique();
                            var html = '';
                            var sameTour;
                            if (tours && tours.length) {
                                for (var i in tours) {
                                    sameTour = tours[i];
                                    if (sameTour.nights === Number(tour.nights) &&
                                        sameTour.date === tour.date &&
                                        sameTour.meal === tour.meal) {
                                        continue;
                                    }
                                    html += self.createRowHtml(sameTour, 'same', c_row_id);
                                }
                            } else {
                                // если поиск не нашел туры, то берем их из таблицы
                                html = getSameHotelsFromHotTable();
                            }
                            $('.hotels-find-wrapper').remove();
                            $("#p" + c_row_id.slice(1)).after(html);
                        }
                    }
                );
            } else {
                $('.hotels-find-wrapper').remove();
                $("#p" + c_row_id.slice(1)).after(getSameHotelsFromHotTable());
            }
        } else {
            $("#" + c_row_id).after(getSameHotelsFromHotTable());
        }

        this.options.openedHotels[group_key] = 1;
    },

    closeSameHotels: function (row_id) {
        $('.same-hotels-r' + row_id).remove();
        var group_key = this.get_group_key('r' + row_id);
        delete(this.options.openedHotels[group_key]);
    },

    get_group_key: function (row_id) {
        return this.options.data[row_id]['values']['is_combined'] && parseInt(this.options.data[row_id]['values']['hotel_id'])
            ? this.options.data[row_id]['values']['hotel_id'] : this.options.data[row_id]['values']['hotel'];
    },

    getCheapRow: function (row) {
        var tpl = this.options.templates.hotels.row, d = row['values'];
        tpl = tpl.split(this.options.b.start + 'date' + this.options.b.end).join(d['date']);
        tpl = tpl.split(this.options.b.start + 'city' + this.options.b.end).join(d['departCity']);
        tpl = tpl.split(this.options.b.start + 'days' + this.options.b.end).join(d['nights']);
        tpl = tpl.split(this.options.b.start + 'meal' + this.options.b.end).join(d['meal']);
        tpl = tpl.split(this.options.b.start + 'operator' + this.options.b.end).join(d['operator']);
        tpl = tpl.split(this.options.b.start + 'price' + this.options.b.end).join(d['price'] + d['cur']);
        if (this.options['selectable']) {
            if (row['sended']) {
                tpl = tpl.split(this.options.b.start + 'button' + this.options.b.end).join('Выбрано');
            } else {
                tpl = tpl.split(this.options.b.start + 'button' + this.options.b.end).join('<a class="cheap_hotels_select" data-id="' + d['id'] + '">Выбрать</a>');
            }
        } else {
            if (row['visible']) {
                tpl = tpl.split(this.options.b.start + 'button' + this.options.b.end).join('<a class="cheap_hotels_go" href="#r' + d['id'] + '">Перейти</a>');
            } else {
                tpl = tpl.split(this.options.b.start + 'button' + this.options.b.end).join('');
            }
        }

        if (row['visible']) {
            tpl = tpl.split(this.options.b.start + 'filter' + this.options.b.end).join('<span class="cheap_hotels_nonfiltered">Видимый</span>');
        } else {
            tpl = tpl.split(this.options.b.start + 'filter' + this.options.b.end).join('<span class="cheap_hotels_filtered">Отфильтрован</span>');
        }

        tpl = tpl.split(this.options.b.start + 'selected' + this.options.b.end).join(row['selected'] ? 'selected' : (row['sended'] ? 'sended' : ''));
        tpl = tpl.split(this.options.b.start + 'new' + this.options.b.end).join(row['newReq'] ? 'new' : '');
        return tpl;
    },

    get: function (item) {
        return this[item];
    },

    //Обновить фильтр
    refreshFilter: function (ff, ff_key) {
        if (this.options['debug']) tmSt('refreshFilter');
        var filters = this.options['filters'], item, html = '', f_val, $item, sort = false;
        var $filter;
        var isTable = this.options.isTable;
        var ffParams;
        var filterCheckedParams = typeof(this.options['filterCheckedParams']) !== 'undefined' ? this.options['filterCheckedParams'] : [];
        if (isTable) {
            $(".filterTbl label").addClass('visible');
        } else {
            $(".filterTbl button").addClass('visible');
        }
        $(".filterTbl input").removeAttr('disabled');

        for (ff_key in filters) {
            if (this.options['debug']) tmSt('refreshFilter_array_' + ff_key);
            sort = false;
            ff = filters[ff_key];
            ffParams = typeof(filterCheckedParams[ff_key]) !== 'undefined' ? filterCheckedParams[ff_key] : [];
            $filter = $("#filterTbl_" + ff_key);
            if ($filter.length === 0) continue;
            var $values = $filter.children('.values');
            if (ff.hasOwnProperty('forceUpdate') && ff['forceUpdate']) {
                $values.empty();
            }
            for (f_val in ff['values']) {
                item = ff['values'][f_val];
                ///log('item');
                //debug(item);
                if (!item['rendered'] || (ff.hasOwnProperty('forceUpdate') && ff['forceUpdate'])) {
                    html = this._renderFilterItem(ff_key, item);
                    $values.append(html);
                    item['rendered'] = true;
                    sort = true;
                }
                $item = $filter.find('input[value="' + item['value'] + '"]');
                var $par = $item.parent();
                if (ff['values'][f_val]['count'] > 0) {
                    var cnt = ff['values'][f_val]['count'];
                    var tpl = this.options.templates.cntText;
                    tpl = tpl.split('{{cnt}}').join(cnt);
                    $par.find('.count').text(tpl);
                    var t = cnt + " " + getnoun(cnt, 'тур', 'тура', 'туров');
                    $par.find('.sp').prop('title', t);
                    if (ffParams.indexOf(ff['values'][f_val]['value']) !== -1) {
                        $item.prop('checked', true);
                        if (!this.options.isTable) {
                            $par.addClass('checked');
                        }
                    }
                } else {

                    if (!$item.is(":checked")) {
                        //$par.hide();
                        $par.find('.count').text('(0 вар.)');
                        // не блокировать чекбоксы при немгновенном фильтре. Для удобства.
                        if (this.options['instantFilter']) {
                            $par.removeClass('visible');
                            $item.attr('disabled', 'disabled');
                        }
                    }
                }

            }
            ff['forceUpdate'] = false;
            if (this.options['debug']) tmEnd('refreshFilter_array_' + ff_key);
            //сортировка
            if (sort) {
                if (this.options['debug']) tmSt('refreshFilter_sort_' + ff_key);
                var vals = [], objs = [];
                $values.find('input').each(function () {
                    var v = $(this).val();
                    vals.push(v);
                    if ($(this).prop('checked')) $(this).attr('checked', true);
                    else $(this).attr('checked', false);
                    if (isTable) {
                        objs[v] = $(this).parent()[0].outerHTML;
                    }
                    else {
                        objs[v] = $(this).closest('.item')[0].outerHTML;
                    }
                    //objs[v] = $(this).parent();
                });
                switch (ff_key) {
                    case "nights":
                        vals.sort(function (a, b) {
                            return a - b;
                        });
                        break;
                    case "priceBound":
                        vals.sort(function (a, b) {
                            a = a.substr(4);
                            a = parseInt(a);
                            b = b.substr(4);
                            b = parseInt(b);
                            return a - b;
                        });

                        break;
                    case 'class':
                        vals.sort(function (a, b) {
                            if (parseInt(a) && parseInt(b)) {
                                return b - a;
                            } else {
                                if (!parseInt(a)) {
                                    return 1;
                                }
                                if (!parseInt(b)) {
                                    return -1;
                                }
                            }
                            return 0;
                        });
                        break;
                    case 'meal':
                    case 'region':
                        vals.sort(function (a, b) {
                            if (ff['values'][a]['count'] > ff['values'][b]['count']) {
                                return -1;
                            } else if (ff['values'][a]['count'] < ff['values'][b]['count']) {
                                return 1;
                            }
                            return 0;
                        });
                        break;
                    case 'date':
                        vals.sort(function (a, b) {
                            var da = moment(a, 'DD.MM').toDate();
                            var db = moment(b, 'DD.MM').toDate();
                            if (da > db) {
                                return 1;
                            } else if (db > da) {
                                return -1;
                            }
                            return 0;
                        });
                        break;
                    default:
                        vals.sort();
                        break;
                }
                //$values.empty();
                var h = '', k;
                for (k in vals) {
                    h += objs[vals[k]];
                    //$values.append(objs[vals[k]]);
                }
                $values.html(h);
                if (this.options['debug']) tmEnd('refreshFilter_sort_' + ff_key);
            }

        }
        if (this.options['debug']) tmEnd('refreshFilter');
    },

    // восстанавливаем только те параметры, для которых есть запись в фильтрах
    _setFilterParams: function(filterParams) {
        var filters = this.options['filters'];
        var ff_key,
            val_key;
        var newFP = {};
        for (ff_key in filters) {
            if (!filters.hasOwnProperty(ff_key)) {
                continue;
            }
            if (filterParams.hasOwnProperty(ff_key)) {
                for (val_key in filters[ff_key]['values']) {
                    if (filterParams[ff_key].indexOf(filters[ff_key]['values'][val_key]['value']) !== -1
                    // && filters[ff_key]['values'][val_key]['count'] > 0
                    ) {
                        if (typeof(newFP[ff_key]) === 'undefined') {
                            newFP[ff_key] = [];
                        }
                        newFP[ff_key].push(filters[ff_key]['values'][val_key]['value']);
                    }
                }
            }
        }
        this._setOption('filterParams', newFP);
    },

    // значения, которые по умолчанию должны быть у value из filter[key]['values']
    _getFilterValueDefaultParams: function (p) {
        var ft = [];
        ft['count'] = p.hasOwnProperty('count') ? p.count : 0;
        ft['all_count'] = p.hasOwnProperty('all_count') ? p.all_count : 0;
        ft['forceUpdate'] = p.hasOwnProperty('forceUpdate') ? p.forceUpdate : false;
        ft['hidden'] = p.hasOwnProperty('hidden') ? p.hidden : false;
        ft['rendered'] = p.hasOwnProperty('rendered') ? p.rendered : false;
        ft['value'] = p.value;
        return ft;
    },

    //Сбросить все фильтры
    _resetFilter: function() {
        if (this.options['debug']) tmSt('_resetFilter');
        //log(params);
        var that = this;
        var params = {};

        var $filter = this._options['elems'].filter;

        if (this.options.isTable) {
            $filter.find('.values input:checked').attr('checked', false);
        }
        else {
            var $checkedBtns = $filter.find('.values button.checked');
            $checkedBtns.find('input').attr('checked', false);
            $checkedBtns.removeClass('checked');
        }

        that._setOption('filterParams', params);
        that._setOption('filterCheckedParams', {});
        that._updateFilterDesc();
        //Проверяем какие строки надо показать
        that._checkVisible();
        //Показываем/скрываем строки в талице
        that._refresh();
        //Пересчитываем кол-во значений фильтра
        var filters = that._calcFilters(params);

        //обновляем фильтры
        that.refreshFilter();
        //Обновляем значения фильтра
        that._setOption('filters', filters);

        if (that.options.onAfterFilter && typeof that.options.onAfterFilter === 'function') that.options.onAfterFilter();

        if (this.options['debug']) tmEnd('_resetFilter');
    },

    //Текстом описание выбранных фильтров по категории
    _getFilterDesc: function (ff_key, values) {

        var allowedFilters = [
            'class', 'region', 'nights', 'meal', 'priceBound', 'date', 'departCity',
            // 'category',
        ];
        var res = '';
        var ASort = function (a, b) {
            return a - b;
        };

        if (allowedFilters.indexOf(ff_key) + 1) {
            res = 'Не указано';

            if (values.length) {
                switch (ff_key) {
                    case 'class':
                        values = values.sort(ASort);
                        var len = values.length;
                        var last = parseInt(values[len - 1]);
                        res = values.join(', ') + ' звезд' + getnoun(last, 'а', 'ы', '');
                        break;
                    case 'nights':
                        values = values.sort(ASort);
                        var len = values.length;
                        var last = parseInt(values[len - 1]);
                        res = values.join(', ') + ' ' + getnoun(last, 'день', 'дня', 'дней');
                        break;
                    case 'date':
                    case 'priceBound':
                    case 'region':
                    case 'meal':
                    case 'departCity':
                        res = values.join(', ');
                        break;
                }
            }

        }

        return res;
    },

    _updateCountVisible: function () {
        if (!this.options.refreshFilterDesc) return false;
        var $btnSelFilters = this.element.find('.select_filters');
        if (this.options['instantFilter'] && $btnSelFilters.length) {
            $btnSelFilters.html('Показать ' + this.options.countVisible +
                ' результат' + getnoun(this.options.countVisible, '', 'а', 'ов'));
        }
    },

    _updateFilterDesc: function () {
        if (!this.options.refreshFilterDesc) return false;

        var $filter = this._options['elems'].filter;
        var filterCheckedParams = this.options['filterCheckedParams'];
        var values;
        var desc;
        var ff_key;
        //this._updateCountVisible();

        var filters = this.options['filters'];
        for (ff_key in filters) {
            values = [];
            if (filterCheckedParams.hasOwnProperty(ff_key)) {
                values = filterCheckedParams[ff_key];
            }
            desc = this._getFilterDesc(ff_key, values);
            if (desc.length) {
                var $descPlace = $filter.find('.item[data-filter="' + ff_key + '"] .hint');
                var prevDesc = $descPlace.html();
                $descPlace.html(desc);
                if (prevDesc !== desc) {
                    $descPlace.data('highlight', 1);
                }
            }
        }

        var count = 0;
        var selectedFilterCount = parseInt($filter.data('count'), 10) || 0;
        for (ff_key in filterCheckedParams) {
            if (filterCheckedParams.hasOwnProperty(ff_key)) {
                count++;
            }
        }
        if (count !== selectedFilterCount) {
            $filter.data('count', count);
            var $openFilterBtnCount = $('.open_ht_filter .count');
            if ($openFilterBtnCount.length) {
                if (count > 0) {
                    $openFilterBtnCount.text(count);
                    $openFilterBtnCount.addClass('visible');
                } else {
                    $openFilterBtnCount.text('');
                    $openFilterBtnCount.removeClass('visible');
                }
            }
        }
    },

    //Что показывать, а что нет.
    _checkVisible: function () {
        if (this.options['debug']) tmSt('_checkVisible');
        var tableData = this.options['data'], dd, countVisible = 0,
            params = this.options['filterParams'];
        if ('function' === typeof(this.options.checkVisible)) {
            tableData = this.options.checkVisible(tableData, params);
        } else {
            var f;
            for (var row_id in tableData) {
                f = true;
                dd = tableData[row_id]['values'];
                if (this.options.onlyBestPrice && !dd['isBestPrice']) f = false;
                if (this.options.onlyFavHotels && !dd['isFavoriteHotel']) f = false;
                if (this.options.onlyPremium && parseInt(dd['category'], 10) !== 2) f = false;
                if (this.options.onlyMomentConfirm && !dd['moment_confirm']) f = false;
                if (this.options.onlyGuaranteeConfirm && !dd['guarantee_confirm']) f = false;
                if (this.options.mode === 'map' && (!dd['coords'] || !dd['coords'][0] || !dd['coords'][1])) f = false;
                if (this.options.onlyCheckedHotels &&
                    this.popupPricesHotelIds.indexOf(parseInt(dd.hotel_id, 10)) === -1) {
                    f = false;
                }
                for (var name in params) {
                    if ($.inArray(dd[name], params[name]) == -1) f = false;
                }
                tableData[row_id]['visible'] = f;
                if (f) countVisible++;
            }
        }
        this._setOption('data', tableData);
        this._setOption('countVisible', countVisible);
        this._updateCountVisible();

        if (this.options['debug']) tmEnd('_checkVisible');
    },

    /**
     * In mobile version triggers from map.js
     * allowedModes: map || list
     * @param $elem
     * @returns {boolean}
     * @private
     */
    _changeMode: function () {

        if ($(this).hasClass('disabled')) return false;
        this.options.mode = this.options.mode === 'list' ? 'map' : 'list';

        /* Собираем чекнутые значения фильтра */
        var params = this.options['filterParams'];

        //log(params);
        this._setOption('filterParams', params);
        //Проверяем какие строки надо показать
        this._checkVisible();

        this._updateFilterDesc();
        //Показываем/скрываем строки в талице
        this._refresh();

        //Пересчитываем кол-во значений фильтра
        var filters = this._calcFilters(params);

        //обновляем фильтры
        this.refreshFilter();
        //Обновляем значения фильтра
        this._setOption('filters', filters);

        if (this.options.onAfterFilter && typeof this.options.onAfterFilter == 'function') this.options.onAfterFilter();

    },

    //Очистка таблицы
    clear: function (change_html, change_options) {
        if (this.options['debug']) tmSt('clear');
        change_options = typeof(change_options) === 'object' ? change_options : {};
        change_html = typeof(change_html) !== 'undefined' ? change_html : true;
        var $filter = this._options['elems'].filter || null;
        if ($filter === null) return false;
        //Зачищаем переменные
        var filters = this.options['filters'];
        for (var k in filters) {
            filters[k]['values'] = [];
        }

        var isNeedPreserveFilterSelected = change_options.hasOwnProperty('isNeedPreserveFilterSelected');
        if (isNeedPreserveFilterSelected) {
            this._setOption('preserveFilterSelected', {
                'isNeed': true,
                'params': this.options['filterParams']
            });
        }

        this._setOption('filters', filters);
        this._setOption('data', []);
        this._setOption('hashList', []);
        this._setOption('filterParams', {});
        this._setOption('filterCheckedParams', {});
        this._setOption('openedHotels', []);
        this._setOption('countView', this.options['baseCountView']);
        this._setOption('firstAdd', false);
        this._setOption('page', 1);
        this._setOption('pageCount', 0);
        this.options.tourViewUrlParams = '';


        //Очищаем фильтр
        //$filter.find('.filterHead, .filterBody').empty();
        var isTable = this.options.isTable;
        if (change_html) $filter.find(( isTable ? '.filterBody ' : '' ) + '.values').empty();
        //Очищаем таблицу
        if (change_html) this.element.find(( isTable ? '' : '.' ) + 'tbody').empty();

        if (change_html && this._options.elems.button)
            this._options.elems.button.removeClass('visible');

        this._refresh();
        this.popupPricesHotelId = '';
        this.popupPricesHotelIds = [];

        // генерация события clear
        this._trigger("clear");
        if (this.options['debug']) tmEnd('clear');
    },

    changeMode: function () {
        this._changeMode();
    },

    getAirlinesKey: function(value) {
        var result = '';
        if (typeof window.getAirlinesKey === 'function') {
            result = window.getAirlinesKey(value);
        }

        return result;
    },

    // Хеш, по которому схлопываются туры
    getRowHash: function(row) {
        var hashResult = '';

        if (this.options.useHash) {
            var hash_st = row['hotel'] + row['region'] + row['class'] + row['date'] + row['departCity']
                + row['rcmGood'] + row['meal'] + row['nights'];
            // + row['transporter'];
            if (this.options.useOperatorHash) {
                hash_st += row['transporter'] + row['operator'] + row.promoPrice;
            }
            if (window.searchOnlyHotels) {
                hash_st += row['roomType'];
            }
            hashResult = hex_md5(hash_st);
        }
        return hashResult;
    },

    // Добавить несколько строк

    /**
     * @NOTE при добавлении привидения к типу, проверьте фильры
     *      можно сломать т.к. $.inArray(2, ["2"]) === -1
     */
    addRows: function (rows) {
        var l_debug = false;
        if (l_debug) {
            var l_debug_num = Math.floor(Math.random() * (1000 - 0 + 1)) + 0;
            console.log('addRows start ' + l_debug_num);
        }

        //log('----------');
        //log('addRows');
        if (this.options['debug']) tmSt('addRows');
        //console.log("Rows add: " + count(rows));
        var tableData = this.options['data'],
            hashList = this.options['hashList'],
            filters = this.options['filters'],
            params = this.options['filterParams'],
            that = this;

        //Добавить в options.data
        if (this.options['debug']) tmSt('addRows: check data');
        var indArr = {}, minBound, maxBound, k;
        for (key in rows) {
            // Копируем объект, т.к. дальше он будет мутировать и свойства будут приводиться к строкам
            const row = $.extend(true, {}, rows[key]);
            if (rows[key].photo && rows[key].getPhoto) {
                row.photo = rows[key].getPhoto(app.isMobile ? 'sm' : 'sm4x3');
            }
            const t = {};
            t['values'] = {};
            t['values']['cheap'] = 0;	//количество более дешевых
            t['showPrices'] = this.options['showPrices'];
            t['comment'] = '';
            t['managersComments'] = '';
            t['new'] = true;
            t['rendered'] = false;
            t['selected'] = false;
            t['sended'] = false;
            t['newReq'] = row.newReq; //данные из нового поиска (не первого)
            t['visible'] = true;
            t['cur_visible'] = true;
            t['cheapList'] = [];	//список более дешевых
            t['hash'] = '';

            // Перебиваем для поиска на totalDays
            // (в row.totalNights на самом деле totalDays. Как вы поняли в nights дни -_- )
            if (row.hasOwnProperty('totalNights') && row.totalNights) {
                row.nights = row.totalNights;
            }

            for (k in row) {
                switch (k) {
                    case 'price':
                        row[k] = parseInt(row[k], 10);
                        var ts = Math.floor(row[k] / 500);
                        minBound = ts * 500;
                        maxBound = (ts + 1) * 500;
                        if (row.cur == '$') {
                            t['values']['priceBound'] = "от " + row.cur + minBound + " до " + row.cur + maxBound;
                        } else {
                            t['values']['priceBound'] = "от " + minBound + row.cur + " до " + maxBound + row.cur;
                        }
                        break;
                    case 'popularity':
                    case 'category':
                        row[k] = parseInt(row[k], 10) || 0;
                        break;
                    case 'priceLogSum':
                        row[k] = parseInt(row[k], 10);
                        break;
                    case 'meal':
                        row[k] = "" + row[k];
                        // Если есть амперсанты, то ломается всё нафиг
                        row[k] = row[k].split(' & ').join(' AND ');
                        row[k] = row[k].split(' &amp; ').join(' AND ');
                        row[k] = row[k].split('&amp;').join(' AND ');
                        row[k] = row[k].split('&').join(' AND ');
                        // ломаются фильтры
                        row[k] = row[k].split('"').join("'");
                        break;
                    case 'hasSurcharges':
                        let value = 0;
                        if (row[k] === 'true' || +row[k] === 1 || row[k] === true) {
                            value = 1;
                        }
                        row[k] = value;
                        break;

                    default:
                        // Неуказанные свойства к строке (аккуратнее с объектами)
                        if (['coords', 'priceLog', 'isBestPrice', 'priceInfo', 'is_combined',
                            'moment_confirm', 'guarantee_confirm', 'domesticFlights', 'flights',
                            'promoPrice', 'airlineCodes', 'rooms', 'hasSurcharges'].indexOf(k) === -1) {
                            row[k] = "" + row[k];
                        }
                        break;
                }

                t['values'][k] = row[k];
            }



            t['values']['operators'] = [row['operator']];   // у каких операторов есть туры в этот отель
            t['hash'] = this.getRowHash(row);
            var ind = 'r';
            if (row.id) {
                ind += row.id;
            } else {
                ind += Math.floor(Math.random() * (100000 - 10000 + 1)) + 10000;
            }
            indArr[ind] = t;
        }
        //indArr.sort(this._sortByPrice);
        if (this.options['debug']) tmEnd('addRows: check data');
        //Проверяем на дубли
        i = count(indArr);
        var excludeRows = [];
        if (this.options.useHash) {
            if (this.options['debug']) tmSt('addRows: hash');
            if (this.options['debug']) tmSt('addRows: hash_array');
            var delArr = [];
            var rowID, tData;
            for (ind in indArr) {
                row = indArr[ind];
                //если совпал хеш
                if (hashList.hasOwnProperty(row['hash'])) {
                    i--;
                    rowID = hashList[row['hash']]['id'];
                    tData = tableData[rowID];
                    if (row['values']['price'] < tData['values']['price']) {
                        //если предыдущая цена больше, то запоминаем эту строку и помечаем на удаление
                        delArr.push(rowID);
                        excludeRows.push(ind);
                    } else if (row['values']['price'] > tData['values']['price']) {
                        //если цена в таблице меньше, игнорируем
                        delete indArr[ind];
                    } else {
                        //если равны, игнорируем новую строку
                        delete indArr[ind];
                    }
                }
            }


            if (this.options['debug']) tmEnd('addRows: hash_array');
            //console.debug(delArr);
            if (delArr.length > 0) {
                //console.log("delArr add: " + delArr.length);
                this.removeRows(delArr, false);
                tableData = this.options.data;
            }
            if (this.options['debug']) tmEnd('addRows: hash');
        }
        if (typeof hotels_count !== 'undefined')
            hotels_count += i;

        //console.log("indArr count: " + count(indArr));
        //hotels_count += count(indArr);
        //console.log("hotels_count: " + hotels_count);
        //Ищем месте, куда надо вставить строку - ищем наименьшее из значений, больших чем цена вставляемого элемента
        if (this.options['debug']) tmSt('addRows: html insert');
        //делаем merge c tableData
        if (this.options['debug']) tmSt('addRows: html insert: merge');
        for (key in indArr) {
            tableData[key] = indArr[key];
            if (this.options.useHash) {
                hashList[indArr[key]['hash']] = {
                    id: key,
                    price: indArr[key]['values']['price']
                };
            }
        }
        if (this.options['debug']) tmEnd('addRows: html insert: merge');

        //сортируем по возрастанию цены
        if (this.options['debug']) tmSt('addRows: html insert: sort');
        var tuples = [];
        for (key in tableData) tuples.push([key, tableData[key]]);
        tuples = this._resortTuples(tuples);

        /*
        tuples.sort(function (a, b) {
            var af = a[1]['values'][that.options.sortBy];
            var aid = parseInt(a[1]['values']['id']);
            var bf = b[1]['values'][that.options.sortBy];
            var bid = parseInt(b[1]['values']['id']);
            switch (that.options.sortFilters[that.options.sortBy]['direct']) {
                case 'DESC':
                    return a < b ? 1 : (a > b ? -1 : (aid < bid ? 1 : (aid > bid ? -1 : 0)));
                    break;
                default:
                    return af < bf ? -1 : (af > bf ? 1 : (aid < bid ? -1 : (aid > bid ? 1 : 0)));
                    break;
            }
        });*/

        if (this.options['checkCheap']) {
            if (this.options['debug']) tmSt('addRows: html insert: checkCheap');
            var cheap_hotels = [], nm, tp, tp_key;
            for (i = 0; i < tuples.length; i++) {
                tp = tuples[i][1];
                tp_key = tuples[i][0];
                nm = tp['values']['hotel'];
                if (!cheap_hotels[nm]) {
                    cheap_hotels[nm] = [tp_key];
                } else {
                    tp['values']['cheap'] = cheap_hotels[nm].length;
                    tp['cheapList'] = [].concat(cheap_hotels[nm]);
                    cheap_hotels[nm].push(tp_key);
                }
            }
            if (this.options['debug']) tmEnd('addRows: html insert: checkCheap');
        }

        var td = {};
        var len = tuples.length;
        for (var i = 0; i < tuples.length; i++) {
            var key = tuples[i][0];
            td[key] = tuples[i][1];
        }
        tableData = td;
        if (this.options['debug']) tmEnd('addRows: html insert: sort');

        if (this.options['debug']) tmSt('addRows: html insert: calcSameHotels');
        var sameHotels = {}, updateRows = [], group_key;
        for (k in tableData) {
            row = tableData[k];
            group_key = this.get_group_key(k);
            if (!sameHotels.hasOwnProperty(group_key)) {
                sameHotels[group_key] = {
                    items: [k],
                    operators: [row['values']['operator']]
                }
            } else {
                if (find(sameHotels[group_key]['operators'], row['values']['operator']) !== -1) {
                    //если оператор уже есть в списке
                    if (sameHotels[group_key]['operators'].length > (row['values']['operators'] || []).length) {
                        tableData[k]['values']['operators'] = sameHotels[group_key]['operators'];
                        if (row['rendered']) updateRows.push(k);
                    }
                } else {
                    //если оператора нет в списке
                    sameHotels[group_key]['items'].push(k);
                    sameHotels[group_key]['operators'].push(row['values']['operator']);
                    sameHotels[group_key]['items'].forEach(function (row_id) {
                        tableData[row_id]['values']['operators'] = sameHotels[group_key]['operators'];
                        if (tableData[row_id]['rendered']) updateRows.push(row_id);
                    });
                }
            }
        }
        if (this.options['debug']) tmEnd('addRows: html insert: calcSameHotels');

        if (updateRows.length > 0) {
            if (this.options['debug']) tmSt('addRows: html insert: updateRows');
            var tmp, v, tip, tipText;
            updateRows.forEach(function (row_id) {
                tmp = [];
                if (tableData[row_id]['values']['operators'].length > 1) {
                    tableData[row_id]['values']['operators'].forEach(function (operator) {
                        if (operator != tableData[row_id]['values']['operator']) {
                            v = operator;
                            if (that.options.showMarkups && typeof(window.toursMarkup) != "undefined" &&
                                window.toursMarkup.hasOwnProperty(operator)) {
                                tipText = 'нет комментария';
                                if (window.toursMarkup[operator]['reason'] != "") {
                                    tipText = window.toursMarkup[operator]['reason'];
                                }
                                tipText += '. ' + window.toursMarkup[operator]['managerName'];
                                tip = 'data-toggle="tooltip" data-placement="top" title="' + tipText + '"';
                                v += " <span class='tourMarkup' " + tip + ">(" + (window.toursMarkup[operator]['price'] > 0 ? "+" : "") + window.toursMarkup[operator]['price'] + (parseInt(window.toursMarkup[operator]['isPercent']) ? "%" : '') + ")</span>";
                            }
                            tmp.push(v);
                        }
                    });
                }
                $("#operatorsList_" + row_id).html(tmp.join(', '));
            });
            if (this.options['debug']) tmEnd('addRows: html insert: updateRows');
        }

        //Добавить в DOM таблицы
        if (this.options['addRowsInsert']) {
            if (this.options['debug']) tmSt('addRows: html insert: html');
            //Формируем html
            var tpl, html = '';
            var htmlArr = [];
            for (ind in indArr) {
                tpl = this.options['template'];
                row = indArr[ind]['values'];
                html = '';
                if (tpl == '') {
                    html += '<tr ';
                    if (row.id) {
                        html += ' id="r' + row.id + '" data-id="' + row.id + '" ';
                    }
                    html += '>';
                    for (k in row) {
                        html += '<td>' + row[k] + '</td>';
                    }
                    html += '</tr>';
                } else {
                    tpl = this.createRowHtml(row);
                    html += tpl;
                }
                htmlArr[ind] = html;
            }

            var prev = -1;
            var cnt = count(tableData), is_new = false, insArr = [], row_id, dd;
            for (row_id in tableData) {
                dd = tableData[row_id];
                is_new = dd['new'] || false;
                if (prev != -1) {
                    insArr[prev] = row_id;
                }
                prev = -1;
                if (is_new) prev = row_id;
            }
            if (prev != -1) {
                if (this.options.isTable) {
                    this.element.find('tbody').append(htmlArr[prev]);
                } else {
                    this.element.find('.tbody').append(htmlArr[prev]);
                }
                tableData[prev]['rendered'] = true;
                tableData[prev]['new'] = false;
            }

            //Вставляем в DOM
            var keys = [];

            for (var k in insArr) {
                keys.unshift(k);
            }

            for (var c = keys.length, n = 0; n < c; n++) {
                key = keys[n];
                var h = htmlArr[key] || "";
                $(h).insertBefore($("#" + insArr[key]));
                tableData[key]['new'] = false;
                tableData[key]['rendered'] = true;
            }
            if (this.options['debug']) tmEnd('addRows: html insert: html');
        }

        this._setOption('data', tableData);
        this._setOption('hashList', hashList);
        if (this.options['debug']) tmEnd('addRows: html insert');
        /*******/

        //Добавить в options.filters

        //log('filters');
        //debug(filters);
        if (this.options['debug']) tmSt('addRows: filters');
        var ff_key;
        for (key in indArr) {
            row = indArr[key]['values'];
            //debug(row);
            if (find(excludeRows, key) != -1) {
                continue;
            }
            for (ff_key in filters) {
                if (!row[ff_key]) continue;

                var ff = filters[ff_key];
                var f_val = row[ff_key];
                if (ff_key == 'rcmGood' && f_val == 0) {
                    continue;
                }
                if (!ff['values'][f_val]) {
                    ff['values'][f_val] = this._getFilterValueDefaultParams({
                        'count': 0,
                        'all_count': 1,
                        'forceUpdate': false,
                        'hidden': false,
                        'rendered': false,
                        'value': f_val,
                    });
                }
                //Проверяем наличие значений в фильтре
                var f = true;
                if (this.options.onlyBestPrice && !row['isBestPrice']) f = false;
                if (this.options.onlyFavHotels && !row['isFavoriteHotel']) f = false;
                if (this.options.onlyPremium && parseInt(row['category'], 10) !== 2) f = false;
                if (this.options.onlyMomentConfirm && !row['moment_confirm']) f = false;
                if (this.options.onlyGuaranteeConfirm && !row['guarantee_confirm']) f = false;
                if (this.options.mode === 'map' && (!row['coords'] || !row['coords'][0] || !row['coords'][1])) f = false;
                if (this.options.onlyCheckedHotels &&
                    this.popupPricesHotelIds.indexOf(parseInt(row.hotel_id, 10)) === -1) {
                    f = false;
                }
                for (var name in params) {
                    if (name == ff_key) {
                        continue;
                    }
                    if ($.inArray(row[name], params[name]) == -1) f = false;
                }

                if (f === true) {
                    if (ff['values'][f_val]) {
                        ff['values'][f_val]['count']++;
                    }
                }
            }
        }

        //debug(filters);

        var isNeedPreserveFilter = this.options.hasOwnProperty('preserveFilterSelected') &&
            this.options['preserveFilterSelected']['isNeed'];
        if (isNeedPreserveFilter) {
            // Если восстанавливаем фильтры, но в результатах нет какого нибудь значения
            // e.g. Выбрали в фильтре 5 звезде. Пытаемся сохранить. Но в новых результатах нет результатов с 5 звездами
            var selectedFilterParams = this.options['preserveFilterSelected']['params'],
                selectedValueIndex,
                selectedValue;
            for (ff_key in filters) {
                if (typeof(selectedFilterParams[ff_key]) === 'undefined') {
                    continue;
                }
                for (selectedValueIndex in selectedFilterParams[ff_key]) {
                    selectedValue = selectedFilterParams[ff_key][selectedValueIndex];
                    if (typeof(filters[ff_key]['values'][selectedValue]) === 'undefined') {
                        filters[ff_key]['values'][selectedValue] = this._getFilterValueDefaultParams({
                            'count': 0,
                            'all_count': 0,
                            'forceUpdate': false,
                            'hidden': false,
                            'rendered': false,
                            'value': selectedValue
                        });
                    }
                }
            }
            this._setOption('filters', filters);
            // Устанавливает параметры с учетом filters выше
            this._setFilterParams(selectedFilterParams);
            // Пересчитываем кол-во значений фильтра
            filters = this._calcFilters(this.options['filterParams']);

            this.options['preserveFilterSelected']['isNeed'] = false;
            this.options['preserveFilterSelected']['params'] = [];
        }
        this._setOption('filters', filters);
        if (this.options['debug']) tmEnd('addRows: filters');
        if (this.options['debug']) tmSt('addRows: refresh');
        //пересчитать, показывать ли строку
        this._checkVisible();
        //обновить фильтр
        this.refreshFilter();
        //обновляем таблицу
        this._refresh();
        if (this.options['debug']) tmEnd('addRows: refresh');
        //событие первой вставки
        if (this.options['firstAdd'] == false) {
            this._updateFilterDesc();
            this._trigger('firstAddEvent');
            this._setOption('firstAdd', true);

            $(document).trigger('onFirstAddEvent');
        }

        if (this.options['debug']) tmSt('addRows: trigger');
        if (this.options['debug']) tmEnd('addRows: trigger');

        //log('end addRows');
        //log('----------');
        if (l_debug) {
            console.log('addRows end ' + l_debug_num);
        }
        if (this.options['debug']) tmEnd('addRows');

        //для вставки коммента в онлайн консультанте
        if (window.rtRunCommand) {
            if (this.options['debug']) tmSt('addRows: rtRunCommand');
            for (ind in indArr) {
                var vals = indArr[ind].values;
                if (vals.comment || vals.commentTemplate) {
                    rtRunCommand(
                        {
                            command: 'setComment',
                            id: vals.id,
                            text: vals.comment,
                            template: vals.commentTemplate,
                            templateText: vals.commentTemplateText
                        });
                }
            }
            if (this.options['debug']) tmEnd('addRows: rtRunCommand');
        }
    },

    markSelected: function (id, value) {
        this.options.data['r' + id]['selected'] = value;
    },

    markSended: function (id, value) {
        this.options.data['r' + id]['sended'] = value;
    },

    changePrice: function (id, value) {
        this.options.data['r' + id]['inpPrice'] = Number(value);
    },

    getAirlinesLogoHtmlFromValue: function(value) {
        var result = '';
        if (typeof window.getAirlinesLogoHtmlFromValue === 'function') {
            result = window.getAirlinesLogoHtmlFromValue(value);
        }

        return result;
    },

    getSurchargesHtml: function() {
        var result = '';
        if (typeof window.getSurchargesHtml === 'function') {
            result = window.getSurchargesHtml();
        }

        return result;
    },

    // @see function.js hotTemplate
    // @see (new TourRow())->setAttributeValues()
    createRowHtml: function (row, type, parent_id) {
        var t = this,
            tpl,
            k,
            setVal = function (val, label) {
                tpl = tpl.split(t.options.b.start + (label ? label : k) + t.options.b.end).join(val);
            };
        var isTable = this.options.isTable;
        var isMobileTable = this.options.mobile;

        var cheapestTour = row.cheapestTour;
        var cheapestTourDataParams = cheapestTour ?
            ' data-id="' + cheapestTour.id + '" data-price="' + cheapestTour.full_price + '"' : '';
        var cheapRow = cheapestTour || row;
        switch (type) {
            /*case 'same_label':
             tpl = t.options['templates']['same_label'];
             setVal(parent_id, 'parent_id');
             break;*/
            case 'mpopup_face':
                tpl = t.options['template'];
                tpl = tpl.replace('r{{id}}', 'p{{id}}');
                break;
            case 'same':
                tpl = t.options['templates']['same'];
                setVal(parent_id, 'parent_id');
                break;
            default:
                tpl = t.options['template'];
                break;
        }
        var cls = '', tmp = '', ii;

        var hotelNullLabel = t.options.b.start + 'hotel_id_null' + t.options.b.end;
        tpl = tpl.replace(
            hotelNullLabel,
            row.hotel_id === 'null'
                ? '<p class="text-danger"><strong><span class="glyphicon glyphicon-asterisk"></span> Нет' +
                ' склейки</strong></p>'
                : ''
        );

        for (k in row) {
            switch (k) {
                case 'class':
                    var st = '';
                    if (parseInt(row[k])) {
                        var cc = parseInt(row[k]);
                        for (ii = 1; ii <= cc; ii++) {
                            st += "<img src='" + this.options.images_path.star + "' />";
                        }
                        for (ii = cc + 1; ii <= 5; ii++) {
                            st += "<img src='" + this.options.images_path.star_muted + "' " + (this.options.mutedStar ? "class='muted'" : "") + " />";
                        }
                    } else {
                        st = '<span>' + row[k] + '<span>';
                    }
                    tpl = tpl.split(this.options.b.start + 'stars_place' + this.options.b.end).join(st);
                    tpl = tpl.split(this.options.b.start + '' + k + '' + this.options.b.end).join(row[k]);
                    break;
                case 'rcmGood':
                    if (row[k] != 0 && row['hotel_id'] && row['rcmGood'] > 0) {
                        tpl = tpl.split(this.options.b.start + 'recs_place' + this.options.b.end).join('<span class="hotelRec" data-hotel="' + row['hotel_id'] + '"><img src="/img/hico/hotel_like.png" /> ' + row['rcmGood'] + '</span>');
                    } else {
                        tpl = tpl.split(this.options.b.start + 'recs_place' + this.options.b.end).join('');
                    }
                    tpl = tpl.split(this.options.b.start + '' + k + '' + this.options.b.end).join(row[k]);

                    //рейтинг отелей на основе лайков
                    if (row[k] > 0) {
                        var rating = 5;
                        var max = 7;
                        rating = (row[k] > 7) ? 7 : row[k];
                        rating = (row[k] == 1) ? 5 : Math.floor((5 + (row[k] * 5) / max));
                        tpl = tpl.split(this.options.b.start + 'hotel_recomend_place' + this.options.b.end).join('<div class="hotel_rating"><div class="hotel_rating_wrap" title="Рейтинг продаж: ' + rating + '/10"><div class="hotel_rating_val" style="width:' + (rating * 10) + '%;"></div></div><div class="hotel_rating_info">' + rating + '/10</div></div>');
                    } else {
                        tpl = tpl.split(this.options.b.start + 'hotel_recomend_place' + this.options.b.end).join('');
                    }
                    break;
                case 'managersComments':
                    setVal(
                        row['managersComments'] ? '<img class=\"hotel_comment\" src=\"/img/hico/comm.png\">' : '',
                        'comment'
                    );
                    break;
                case 'cheap':
                    setVal('');
                    /* //не нужно из-за введения группировки по отелям
                     if(row['cheap'] > 0){
                     tpl = tpl.split(this.options.b.start+'cheap'+this.options.b.end).join('<div class=\"cheap_place\" title=\"В выдаче есть более дешевые предложения для данного отеля. Нажмите чтобы посмотреть список.\">'+row['cheap']+'</div>');
                     }else{
                     tpl = tpl.split(this.options.b.start+'cheap'+this.options.b.end).join('<div class=\"cheap_place\" title=\"В выдаче есть более дешевые предложения для данного отеля. Нажмите чтобы посмотреть список.\"></div>');
                     }*/
                    break;
                case 'date':
                    var date = cheapRow.date;
                    if (!window.searchOnlyHotels && !isMobileTable) {
                        setVal(
                            Number(row['hotel_id']) && this.options.editDate ?
                                '<div class="showHotelPrices"' + cheapestTourDataParams + '><span>' + date + '</span></div>' : date
                        );
                    } else {
                        setVal(date);
                    }

                    if (window.searchOnlyHotels) {
                        var dateTo = moment(date, 'DD.MM').add(cheapRow.realTotalNights, 'd').format('DD.MM');
                        setVal(dateTo, 'dateTo');
                    }
                    setVal('', 'dateFromDayOfMonthWithMonthShortcut');
                    setVal('', 'dateFromDayOfMonthWithFullNameMonth');
                    setVal('', 'dateFromDayOfWeekShortcut');
                    setVal('', 'dateToDayOfMonthWithMonthShortcut');
                    setVal('', 'dateToDayOfWeekShortcut');
                    break;
                case 'meal':
                    setVal(cheapRow.meal);
                    break;
                case 'hotel_id':
                    setVal(row['hotel_id']);
                    var isChecked = this.popupPricesHotelIds.indexOf(Number(row['hotel_id'])) !== -1;
                    setVal(Number(row['hotel_id']) ? '<div class=\"findHotel' + (isChecked ? ' visited' : '') + '\"></div>' : '', 'findHotel');
                    setVal(Number(row['hotel_id']) ? '<button class=\"btn btn-success findHotel' + (isChecked ? ' visited' : '') + '\">Проверить цену</button>' : '', 'findHotelButton');
                    var showPrice = t.options['showPrices'] ? true : t.isShowPrice(row);
                    setVal(showPrice ? '' : 'hidden', 'priceVisible');
                    setVal(!showPrice ? '' : 'hidden', 'loupeVisible');
                    var isKnownHotel = !!parseInt(row['hotel_id'], 10);
                    setVal(isKnownHotel ? 'known-hotel' : '', 'known-hotel-class');
                    setVal(isChecked ? 'checked-hotel' : '', 'checked-hotel-class');
                    break;
                case 'transporter':
                    if (row.fly_id) {
                        setVal('<a class="popup" data-width="570" data-href="/tours/default/getFlightDetail?id=' + row.fly_id + '">' + row.transporter + '</a>');
                    } else {
                        setVal(row.transporter);
                    }
                    break;
                case 'operator':
                    setVal(row['operator']);
                    var v = row['operator'];
                    if (0 && this.options.showMarkups && typeof(window.toursMarkup) != "undefined" &&
                        window.toursMarkup.hasOwnProperty(row['operator'])) {
                        var tip, tipText = 'нет комментария';
                        if (window.toursMarkup[row['operator']]['reason'] != "") {
                            tipText = window.toursMarkup[row['operator']]['reason'];
                        }
                        tipText += '. ' + window.toursMarkup[row['operator']]['managerName'];
                        tip = 'data-toggle="tooltip" data-placement="top" title="' + tipText + '"';
                        v += " <span class='tourMarkup' " + tip + ">(" + (window.toursMarkup[row['operator']]['price'] > 0 ? "+" : "") + window.toursMarkup[row['operator']]['price'] + (parseInt(window.toursMarkup[row['operator']]['isPercent']) ? "%" : '') + ")</span>";
                    }
                    setVal('<a href="/tours/default/tour?id=' + row['id'] + '" target="_blank">' + v + '</a>'
                        + ' ', 'tourLink');
                    break;
                case 'discount':
                    var discountValue = parseInt(cheapRow.discount, 10) || 0;
                    setVal(discountValue ? discountValue : '');
                    var discountValueHtml = '';
                    var discountResultWithLongLabelHtml = '';
                    if (discountValue) {
                        discountValueHtml = '<span class="discount-value">-' + discountValue + '%</span>';
                        discountResultWithLongLabelHtml =
                            '<p class="discount-wrapper">Скидка на тур: ' + discountValueHtml + '</p>';
                    }
                    setVal(discountValueHtml, 'discount_place');
                    setVal(discountResultWithLongLabelHtml, 'discountPlaceWithLongLabel');
                    break;
                case 'priceLog':
                    var html = '';
                    if (row[k]) {
                        var log = row[k].slice(-3);	// TODO исправить на стороне сервера. может придти более 3
                        for (var i in log) {
                            var ar = log[i];
                            html += '<span class="' + (ar[0] < 0 ? 'green' : 'red') + '">' + ar[0] + '</span> ' + ar[1] + '<br/>';
                        }
                        html = '<div class="priceLog">' + html + '</div>';
                    }
                    setVal(html);
                    break;
                case 'price_kzt':
                    setVal((app.isManager && row['price_kzt']) ? '<div class="price_kzt">' + nfm(row['price_kzt']) + '&nbsp;тг.</div>' : '');
                    break;
                case 'priceKzt':
                    setVal(nf(Math.ceil(+row['priceKzt'] / 12)), 'formatPriceCredit');
                    break;
                case 'cashbackSum':
                    setVal(nf(Math.ceil((+row['priceKzt'] * 2) / 100)), 'formatCashbackSum');
                    break;
                case 'isBestPrice':
                    var h = '';
                    if (row['isBestPrice']) {
                        h = '<div class="isBestPrice">Выгодное предложение</div>';
                    } else if (app.isManager && Number(row['hotel_id'])) {
                        var text = 'Есть дешевле', priceDate;
                        if (typeof(row['priceInfo']) == 'object' && row['priceInfo'].hasOwnProperty('cheap')) {
                            priceDate = moment(row['priceInfo']['cheap']['date'], 'YYYY-MM-DD');
                            text += "(" + priceDate.format('DD.MM') + ", " +
                                (parseInt(row['priceInfo']['cheap']['nights']) + 1) + " дн.)";
                        }
                        h = '<div class="isNotBestPrice showHotelPrices"' + cheapestTourDataParams + '>' + text + '</div>';
                    }
                    setVal(h);
                    break;
                case 'operators':
                    tmp = [];
                    if (row['operators'].length > 1) {
                        row['operators'].forEach(function (operator) {
                            if (operator != row['operator']) tmp.push(operator);
                        });
                    }
                    setVal(tmp.join(', '));
                    break;
                case 'moment_confirm':
                    var moment_confirm_text = '';
                    if (row.moment_confirm) {
                        moment_confirm_text = ' <span style="color: #e56284; font-size: 20px;" title="моментальное подтверждение">🗲</span>';
                    }
                    setVal(moment_confirm_text);
                    break;
                case 'promoPrice':
                    var promoPriceText = '';
                    if (row.promoPrice) {
                        promoPriceText = ' <span style="color: #a88b4c;">[промо]</span>';
                    }
                    setVal(promoPriceText);
                    break;
                case 'guarantee_confirm':
                    var guarantee_confirm_text = '';
                    if (row['guarantee_confirm']) {
                        guarantee_confirm_text = ' <span style="color: #5d9c0e; font-size: 18px;" title="Гарантированное подтверждение">'
                            + '<i class="glyphicon glyphicon-ok"></i></span>';
                    }
                    setVal(guarantee_confirm_text);
                    break;
                case 'note':
                    var note = '';
                    if (row.note) {
                        note = ' <span style="font-size: 70%">[' + row.note + ']</span>';
                    }
                    setVal(note);
                    break;
                case 'flights':
                    var flights = '';
                    if ((row.flights && row.domesticFlights.length > 0) ||
                        (row.domesticFlights && row.domesticFlights.length > 0)
                    ) {
                        flights = '<span ' +
                            'class="glyphicon glyphicon-list flights-info cursor-pointer" ' +
                            'title="Детали перелетов"></span>';
                    }

                    setVal(flights);
                    break;
                case 'totalNights':
                    var totalNights = parseInt(row.totalNights);
                    var nights = parseInt(row.nights);
                    if (totalNights > nights) {
                        totalNights = ('+' + (totalNights - nights));
                    } else {
                        totalNights = '';
                    }
                    setVal(totalNights);
                    break;
                case 'review_grade':
                    if (row['review_grade'] > 0) {
                        tpl = tpl.split(this.options.b.start + 'review_grade' + this.options.b.end).join('<a class="popup review_grade_link" data-href="/review/hotel/id/' + row['hotel_id'] + '" data-width="1200"><i class="icon-user"></i>&nbsp;' + row['review_grade'] + '</a>');
                        //tpl = tpl.split(this.options.b.start+'review_grade'+this.options.b.end).join('<span style="white-space: nowrap;" title="Средняя оценка по отзывам клиентов"><i class="icon-user"></i>&nbsp;'+row['review_grade']+'</span>');
                    } else {
                        tpl = tpl.split(this.options.b.start + 'review_grade' + this.options.b.end).join('');
                    }
                    break;
                // нужно дублировать в hotTemplate function.js
                case 'price_old':
                    var oldPriceVal = Number(cheapRow.price_old) ? nfm(cheapRow.price_old) + cheapRow.cur : '';
                    if (isTable) {
                        oldPriceVal = "<span class='oldPrice'>" + oldPriceVal + "</span><br />"
                    }
                    setVal(oldPriceVal.length ? oldPriceVal : '', 'price_old_place');
                    break;
                case 'price':
                    setVal(cheapRow.price);
                    setVal(nfm(cheapRow.price), 'formatPrice');
                    setVal(row.priceCalculated ? ' price-calculated' : '', 'priceCalculatedClass');
                    setVal(t.options.lazyPrices && !row.priceCalculated ? ' lazy_price_wrap' : '', 'lazyPriceClass');
                    setVal(cheapestTourDataParams, 'cheapestTourData');
                    if (row.showDiscount && row.priceCalculated) {
                        // Показываем скидку сразу
                        tpl = tpl.split(' hide_discount').join('');
                    }
                    break;
                case 'priceForOne':
                    setVal(cheapRow.priceForOne);
                    setVal(nfm(cheapRow.priceForOne), 'formatPriceForOne');
                    break;
                case 'priceForTour':
                    setVal(cheapRow.priceForTour);
                    setVal(nfm(cheapRow.priceForTour), 'formatPriceForTour');
                    var discountValue = parseInt(cheapRow.discount, 10) || 0;
                    var priceForTourOld = discountValue ? Math.ceil(cheapRow.priceForTour / (1 - discountValue/100)) : 0;
                    setVal(
                        priceForTourOld ? nfm(priceForTourOld) + cheapRow.cur : '',
                        'formatPriceForTourOldWithCurrency'
                    );
                    break;
                case 'photo':
                    var src = isMobileTable ? '/img/no-hotel-big.jpg' : '/img/no-hotel.jpg';
                    if (row[k]) {
                        src = row[k];
                    }
                    setVal('<img src="' + src + '"/>');
                    setVal(src, 'photoUrl');
                    break;
                case 'rating':
                    if (row['rating'] > 0) {
                        cls = '';
                        var label = row['rating'];
                        if (row['rating'] >= 7) {
                            cls = 'success rating_place__best';
                        } else if (row['rating'] >= 5) {
                            cls = 'warning rating_place__good';
                        } else {
                            cls = 'danger';
                        }
                        var tmpVal = '<span class="rating_place ' + cls + '" title="Рейтинг отеля">' + label + '/10</span>';
                        setVal(tmpVal, 'rating_place');
                    } else {
                        setVal('', 'rating_place');
                    }
                    break;
                case 'reviewsCount':
                    var result = '';
                    var value = parseInt(row['reviewsCount'], 10);
                    if (value > 0) {
                        result = '<span class="reviews_place">' +
                            value + ' отзыв' + getnoun(value, '', 'а', 'ов') +
                            '</span>';
                    }
                    setVal(result, 'reviews_place');
                    break;
                case 'nights':
                    setVal(row[k]);
                    var nightsValue = parseInt(row[k], 10) || 0;
                    var daysLabel = '';
                    if (nightsValue) {
                        daysLabel = nightsValue + ' ' + getnoun(nightsValue, 'день', 'дня', 'дней');
                    }
                    setVal(daysLabel, 'daysLabel');
                    break;
                case 'realNights':
                    var nightsValue = parseInt(row[k], 10) || 0;
                    var nightsLabel = '';
                    if (nightsValue) {
                        nightsLabel = nightsValue + ' ' + getnoun(nightsValue, 'ночь', 'ночи', 'ночей');
                    }
                    setVal(nightsLabel, 'realNightsLabel');
                    break;
                case 'isRecommended':
                    var isRecommended = parseInt(row[k], 10) || 0;
                    var isRecommendedHtml = '';
                    if (isRecommended === 1) {
                        isRecommendedHtml =
                            '<span class="recommend-badge"><img src="/img/svg/tours/like_white.svg"> Рекомендуем</span>';
                    }
                    setVal(isRecommendedHtml, 'isRecommendedHtml');
                    break;
                case 'operatorSearchLink':
                    if (row.operatorSearchLink) {
                        setVal(
                            '<a target="_blank" href="' + row.operatorSearchLink
                            + '" title="Найти на сайте оператора"><span class="glyphicon glyphicon-search"></span></a>',
                            'operatorSearchLink'
                        );
                    } else {
                        setVal('', 'operatorSearchLink');
                    }
                    break;
                case 'operatorTourLink':
                    if (row.operatorTourLink) {
                        setVal(
                            '<a target="_blank" href="' + row.operatorTourLink
                            + '" title="Перейти к бронированию у оператора">'
                            + '<span class="glyphicon glyphicon-shopping-cart"></span></a>',
                            'operatorTourLink'
                        );
                    } else {
                        setVal('', 'operatorTourLink');
                    }
                    break;
                case 'hasFlightsData':
                    if (row.hasFlightsData === '1') {
                        var link = '<br><a href="#" data-href="/tours/default/getFlightsDetail?id='
                            + row.id + '" class="popup"><span class="glyphicon glyphicon-plane"></span></a>';
                        setVal(link, 'flightsDataLink');
                    } else {
                        setVal('', 'flightsDataLink');
                    }
                    break;
                case 'airlineCodes':
                    setVal('', k);
                    var airlinesLogoHtml = '';
                    airlinesLogoHtml = this.getAirlinesLogoHtmlFromValue(row[k]);
                    setVal(airlinesLogoHtml, 'airlineCodesLogoHtml');
                    break;
                case 'hasSurcharges':
                    var surchargesHtml = '';
                    if (+row[k] === 1 || row[k] === true) {
                        surchargesHtml = this.getSurchargesHtml();
                    }
                    setVal(surchargesHtml, 'surchargesHtml');
                    break;
                case 'notSell':
                    var notSell = '';
                    if (row.notSell) {
                        var rowNotSell = JSON.parse(row.notSell);
                        var notSellTitle = 'Не рекомендуется к продаже, подберите альтернативу. ';
                        notSellTitle += rowNotSell.reason + ' / ' + rowNotSell.author + ' от ' + rowNotSell.createdAt;
                        notSell = '<span class="glyphicon glyphicon-thumbs-down" title="' + notSellTitle + '" style="font-size:' +
                            ' 120%;color:' +
                            ' red;"></span> ';
                    }
                    setVal(notSell, 'notSell');
                    break;
                case 'hasReturnToAnotherCity':
                    var hasReturnToAnotherCity = '';
                    if (row.hasReturnToAnotherCity === 'true') {
                        var title = 'Вылет или возврат в другой город: ' + row.operatorTourName;
                        hasReturnToAnotherCity = ' <span class="glyphicon glyphicon-random" style="color: red" title="' + title + '"></span>';
                    }

                    setVal(hasReturnToAnotherCity, 'hasReturnToAnotherCity');
                    break;
                case 'full_price':
                    setVal(row.full_price, 'full_price');
                    setVal(cheapRow.full_price, 'cheapestTourFullPrice');
                    break;
                case 'id':
                    setVal(row.id, 'id');
                    setVal(cheapRow.id, 'cheapestTourId');
                    break;
                case 'peopleInTour': {
                    if (this.isSplitRoomsSearch()) {
                        if (cheapRow.rooms && cheapRow.rooms.length > 1) {
                            setVal('<span class="tour-rooms-count">' + cheapRow.rooms.length +
                                ' номера</span> на ' + cheapRow.peopleInTour, 'peopleInTour');
                        } else {
                            setVal('1 номер на ' + row.peopleInTour, 'peopleInTour');
                        }
                    } else {
                        setVal(row[k]);
                    }
                    break;
                }
                default:
                    setVal(row[k]);
                    break;
            }
        }
        var classes = [];
        if (this.options.data.hasOwnProperty('r' + row['id'])) {
            var d = this.options.data['r' + row['id']];
            if (this.options.selectable) {
                if (d['selected']) {
                    classes.push('selected');
                } else if (d['sended']) {
                    classes.push('sended');
                }
            }
            if (d['newReq']) {
                classes.push('new');
            }
        }
        setVal(classes.join(' '), 'selected');

        return tpl;
    },

    isShowPrice: function (values) {
        return (values['showPrices'] ||
            (!Number(values['hotel_id']) || this.popupPricesHotelIds.indexOf(Number(values['hotel_id'])) != -1));
    },

    //Перезагрузка таблицы
    reload: function () {
        if (this.options['data'] === null) return false;
        if (this.options['debug']) tmSt('reload');
        this.clear();				//Очищаем таблицу
        this._analyzeData();		//Обрабатывем новые данные
        this._renderFilterData();	//Заполняем фильтр
        this._refresh();			//Обновляем таблицу

        // генерация события reload
        this._trigger("reload");
        if (this.options['debug']) tmEnd('reload');
    },
    refresh: function (f) {
        this._refresh(f);
    },
    //Непосредственно работа фильтра: убираем лишние строки, показываем кнопку
    _refresh: function (f) {
        if (this.options['debug']) tmSt('_refresh');

        $(document).trigger('onBeforeRefresh');

        var visibleRows = [];
        switch (this.options.paginationType) {
            case 'pagination':
                visibleRows = this._refreshWithPage(f);
                break;
            default:
                visibleRows = this._refreshWithButton(f);
                break;
        }
        if (typeof(visibleRows) !== 'object') {
            // Иногда из _refreshWithPage может прилететь undefined || false;
            // причем перед этим снова вызвав this._refresh()
            return false;
        }
        var isSplitRoomsSearch = this.isSplitRoomsSearch();
        if (this.options.markFarResults) {
            var rowId;
            var isFar;
            var filters = this.options.sortable && this.options.sortFilters ? this.options.sortFilters : {};
            var sortBy = this.options.sortBy;
            var globalIsFar = this.options.page > 1
                || (filters && !(sortBy === 'price' && filters.price.direct === 'ASC'))
                || this.options.onlyPremium
                || this.options.filterParams.meal;
            for (var i in visibleRows) {
                isFar = !!isSplitRoomsSearch
                    || globalIsFar
                    || (Number(i) + 1 > this.options.baseCountView);
                rowId = visibleRows[i][0];
                $('#' + rowId)[isFar ? 'addClass' : 'removeClass']('far-result');
            }
        }
        this._trigger('onAfterRefresh', null, {visibleRows: visibleRows});
        $(document).trigger('onAfterRefresh');
        if (this.options['debug']) tmEnd('_refresh');
    },

    isSplitRoomsSearch: function () {
        return !!(
            window.search &&
            window.search.requests.main &&
            window.search.requests.main.params.splitRooms
        );
    },

    _refreshWithButton: function (f) {
        var do_vis = true;
        if (f) do_vis = false;
        var i = 1, cnt = 1, row;
        var tableData = this.options['data'], countView = this.options['countView'];
        var hideArr = [], showArr = [], delArr = [];
        var isTable = this.options.isTable;
        if (this.options['debug']) tmSt('_refresh: show');
        if (do_vis) {
            if (this.options['debug']) tmSt('_refresh: show_remove_visible');
            if (isTable) {
                this.element.find('tbody tr.visible').removeClass('visible');
            } else {
                this.element.find('.tbody .js_tour_item.visible').removeClass('visible');
            }
            if (this.options['debug']) tmEnd('_refresh: show_remove_visible');
        }
        var visibleRows = [];
        if (do_vis && this.options.showHelpLine) {
            if (this.options.isTable) {
                this.element.find('tbody tr.striped').remove();
            } else {
                this.element.find('.tbody .js_tour_item.striped').remove();
            }
        }
        if (this.options['debug']) tmSt('_refresh: show_array');
        var showHotels = {}, sameHotels = [], row_id, dd, f, k, q = 0, showHotels_length = 0,
            group_key;
        for (row_id in tableData) {
            dd = tableData[row_id];
            group_key = this.get_group_key(row_id);
            if (dd['visible']) {
                if (i <= countView) {
                    if (this.options['group']) {
                        if (!showHotels.hasOwnProperty(group_key)) {
                            if (dd['rendered']) {
                                if (do_vis) $("#" + row_id).addClass('visible');
                                // if(do_vis) $("#"+row_id).addClass('need-visible');
                                visibleRows.push([row_id, true]);
                            } else {
                                showArr.push(row_id);
                                visibleRows.push([row_id, false]);
                            }
                            i++;
                        } else {
                            if (dd['rendered']) {
                                delArr.push(row_id);
                            }
                        }
                    } else {
                        if (dd['rendered']) {
                            // if(do_vis) $("#"+row_id).addClass('need-visible');
                            if (do_vis) $("#" + row_id).addClass('visible');
                            visibleRows.push([row_id, true]);
                        } else {
                            showArr.push(row_id);
                            visibleRows.push([row_id, false]);
                        }
                        i++;
                    }
                }
                cnt++;
                if (this.options['group']) {
                    if (!showHotels.hasOwnProperty(group_key)) {
                        showHotels[group_key] = 1;
                        showHotels_length++;
                        sameHotels[group_key] = [dd['values']['id']];
                    } else {
                        f = true;
                        //пробегаем по уже добавленным и проверяем можно ли добавить новый элемент
                        //если в списке уже есть запись с таким или большим кол-вом дней, одинаковым питанием, но меньшей ценой, то не добавляем
                        if (this.options.groupOnlyBest)
                            for (k in sameHotels[group_key]) {
                                row = tableData['r' + sameHotels[group_key][k]]['values'];
                                if (parseInt(row['nights']) >= parseInt(dd['values']['nights']) && row['meal'] == dd['values']['meal'] && parseInt(row['price']) <= parseInt(dd['values']['price'])) {
                                    f = false;
                                    q++;
                                }
                            }
                        if (f) {
                            sameHotels[group_key].push(dd['values']['id']);
                        }
                    }
                }
            }
        }
        if (do_vis) {
            // $(".need-visible", this.element).addClass('visible').removeClass('need-visible');
        }
        if (this.options['debug']) tmEnd('_refresh: show_array');
        if (this.options['group']) {
            if (this.options['debug']) tmSt('_refresh: show_group_remove');
            //удалять надо до рендера новых элементов, чтобы не было повторений id у строк
            this.element.find((isTable ? 'tr' : '') + '.same-hotels').remove();
            this.element.find('.more-hotels-open').removeClass('more-hotels-open');
            if (this.options['debug']) tmEnd('_refresh: show_group_remove');
        }

        if (delArr.length > 0) {
            this.removeRowsFromDOM(delArr);
        }

        if (showArr.length > 0) {
            this._renderTableItems({showArr: showArr, visibleRows: visibleRows, do_vis: do_vis});
        }

        if (!this.options['showPrices']) {
            // скрываем цены только у распознанных отелей, по которым не было проверки через лупу
            $('.known-hotel:not(.checked-hotel) .priceWrapper', this.element).addClass('hidden');
            $('.known-hotel:not(.checked-hotel) .loupeWrapper', this.element).removeClass('hidden');
            // показываем первые 5 цен
            if (this.options.showPricesMode !== SHOW_PRICES_NONE) {
                var firstElems = visibleRows.slice(0, 5);
                for (var ii = 0; ii < firstElems.length; ii++) {
                    var htmlItem = $("#" + firstElems[ii][0]);
                    htmlItem.find('.priceWrapper').removeClass('hidden');
                    htmlItem.find('.loupeWrapper').addClass('hidden');
                }
            }
        }

        if (this.options['group']) {
            if (this.options['debug']) tmSt('_refresh: show_group');
            //выполнять после рендера, когда все строки отрисованы
            this.element.find('.more-hotels').removeClass('visible');
            cnt = showHotels_length;
            var hotel, h = '',
                texts = this.options['texts']['same'], $item;
            for (hotel in sameHotels) {
                row_id = sameHotels[hotel].shift();
                $item = $("#mh" + row_id);
                if (this.options.findSameTours) {
                    $item.html('Больше вариантов').addClass('visible');
                } else {
                    if (sameHotels[hotel].length > 0) {
                        h = '<span>Еще ' + sameHotels[hotel].length + ' ' +
                            getnoun(sameHotels[hotel].length, texts[0], texts[1], texts[2]) + '</span>';
                        if (this.options.openedHotels[hotel]) {
                            $item.data('text', h).addClass('more-hotels-open');
                            if (this.options['moreHotelsPlace'] !== 'mpopup') {
                                h = '<span>Скрыть</span>';
                            }
                        }
                        $item.html(h).addClass('visible');
                    }
                }
                if (this.options.openedHotels[hotel]) {
                    this.showSameHotels(row_id);
                }
            }
            //console.log('отброшено '+q);
            if (this.options['debug']) tmEnd('_refresh: show_group');
        }

        if (this.options['debug']) tmEnd('_refresh: show');


        if (visibleRows.length === 0 && this.options.templates.zeroVisibleItem.length !== 0) {
            if (isTable) {
                this.element.find('tbody').append(this.options.templates.zeroVisibleItem);
            } else {
                this.element.find('.tbody').append(this.options.templates.zeroVisibleItem);
            }
        }

        if (do_vis && this.options.showHelpLine) {
            if (this.options['debug']) tmSt('_refresh: showHelpLine');
            var renderTel = false;
            var renderMail = false;

            var tpl = this.options.templates.help.tel;
            for (i = 8; i < visibleRows.length; i += this.options.baseCountView) {
                renderTel = true;
                if (isTable) {
                    this.element.find('tbody tr.visible:not(.striped):eq(' + i + ')').after(tpl);
                } else {
                    this.element.find('.tbody .js_tour_item.visible:not(.striped):eq(' + i + ')').after(tpl);
                }
            }

            if (!renderTel) {
                if (isTable) {
                    this.element.find('tbody').append(tpl);
                } else {

                    this.element.find('.tbody').append(tpl);
                }
            }

            tpl = this.options.templates.help.mail;
            for (i = 12; i < visibleRows.length; i += this.options.baseCountView) {
                renderMail = true;
                if (isTable) {
                    this.element.find('tbody tr.visible:not(.striped):eq(' + i + ')').after(tpl);
                } else {
                    this.element.find('.tbody .js_tour_item.visible:not(.striped):eq(' + i + ')').after(tpl);
                }
            }

            tpl = this.options.templates.help.includeTemplate;
            for (i = 4; i < visibleRows.length; i += this.options.baseCountView) {
                if (isTable) {
                    this.element
                        .find('tbody tr.visible:not(.striped):eq(' + i + ')')
                        .after(tpl);
                } else {
                    this.element
                        .find('.tbody .js_tour_item.visible:not(.striped):eq(' + i + ')')
                        .after(tpl);
                }
            }

            if (this.options['debug']) tmEnd('_refresh: showHelpLine');
        }

        if (this.options['debug']) tmSt('_refresh: show button');
        //Показываем кнопку
        if ((cnt - 1) > countView) {
            var t = this.options['baseCountView'];
            if ((cnt - 1) - countView < this.options['baseCountView']) {
                t = (cnt - 1) - countView;
            }
            t += " " + getnoun(t, 'тур', 'тура', 'туров');
            this._options.elems.button.find('span').text(t);
            this._options.elems.button.addClass('visible');
        } else {
            this._options.elems.button.removeClass('visible');
        }
        if (this.options['debug']) tmEnd('_refresh: show button');

        //восстанавливаем значения selected и sended
        if (this.options.selectable) {
            if (this.options['debug']) tmSt('_refresh: selectable');
            if (isTable) {
                this.element.find('tbody tr').removeClass('selected sended');
            } else {
                this.element.find('.tbody .js_tour_item').removeClass('selected sended');
            }
            var cl;
            for (row_id in tableData) {
                dd = tableData[row_id];
                if (!dd['rendered']) continue;
                cl = '';
                if (dd['sended']) cl = 'sended';
                else if (dd['selected']) cl = 'selected';

                if (cl != '') {
                    $('#' + row_id).addClass(cl);
                }
            }
            if (this.options['debug']) tmEnd('_refresh: selectable');
        }
        if (this.options['debug']) tmEnd('_refresh');

        return visibleRows;
    },

    _refreshWithPage: function (f) {
        var do_vis = true;
        if (f) do_vis = false;
        var i = 1, cnt = 0;
        var tableData = this.options['data'], countView = this.options['countView'];
        var isTable = this.options.isTable;
        //$("#results tbody tr").hide();
        var hideArr = [], showArr = [];
        if (this.options['debug']) tmSt('_refresh: show');
        if (do_vis) {
            if (isTable) {
                this.element.find('tbody tr.visible').removeClass('visible');
            } else {
                this.element.find('.tbody .js_tour_item.visible').removeClass('visible');
            }
        }
        var visibleRows = [];
        if (do_vis && this.options.showHelpLine) {
            if (isTable) {
                this.element.find('tbody tr.striped').remove();
            }
            else {
                this.element.find('.tbody .js_tour_item.striped').remove();
            }
        }
        var start = (this.options.page - 1) * this.options.countView;	//с какой записи начинается страница	+1
        var end = start + this.options.countView - 1;	//какой заканчивается
        //console.log('start: '+start, 'end: '+end);
        var row_id, dd, showHotels = {}, showHotels_length = 0, sameHotels = {}, row,
            visibleRowsObj = {}, group_key;
        for (row_id in tableData) {
            dd = tableData[row_id];
            group_key = this.get_group_key(row_id);
            if (dd['visible']) {
                if (this.options['group']) {
                    if (!showHotels.hasOwnProperty(group_key)) {
                        if (cnt >= start && cnt <= end) {
                            if (dd['rendered']) {
                                if (do_vis) $("#" + row_id).addClass('visible');
                                visibleRows.push([row_id, true]);
                                visibleRowsObj[row_id] = 1;
                            } else {
                                showArr.push(row_id);
                                visibleRows.push([row_id, false]);
                                visibleRowsObj[row_id] = 1;
                            }
                            i++;
                        }
                        cnt++;
                    }
                } else {
                    if (cnt >= start && cnt <= end) {
                        if (dd['rendered']) {
                            if (do_vis) $("#" + row_id).addClass('visible');
                            visibleRows.push([row_id, true]);
                        } else {
                            showArr.push(row_id);
                            visibleRows.push([row_id, false]);
                        }
                        i++;
                    }
                    cnt++;
                }

                if (this.options['group']) {
                    if (!showHotels.hasOwnProperty(group_key)) {
                        showHotels[group_key] = 1;
                        showHotels_length++;
                        sameHotels[group_key] = [dd['values']['id']];
                    } else {
                        f = true;
                        //пробегаем по уже добавленным и проверяем можно ли добавить новый элемент
                        //если в списке уже есть запись с таким или большим кол-вом дней, одинаковым питанием, но меньшей ценой, то не добавляем
                        if (this.options.groupOnlyBest)
                            for (k in sameHotels[group_key]) {
                                row = tableData['r' + sameHotels[group_key][k]]['values'];
                                if (parseInt(row['nights']) >= parseInt(dd['values']['nights']) && row['meal'] == dd['values']['meal'] && parseInt(row['price']) <= parseInt(dd['values']['price'])) {
                                    f = false;
                                }
                            }
                        if (f) sameHotels[group_key].push(dd['values']['id']);
                    }
                }
            }
        }
        if (this.options['group']) {
            //console.log('showHotels: '+showHotels_length);
            cnt = showHotels_length;
        }

        var pCount = Math.ceil(cnt / this.options.countView);	//кол-во страниц
        //если выбрана страница, на которой нет данных. Например, была выбрана страница 5, после нажатия на фильтр страниц стало 3, открываем третью страницу
        if (this.options.page > 1 && visibleRows.length === 0) {
            this.options.page = pCount;
            this._refresh();
            return;
        }

        if (do_vis) {
            var k, ar;
            for (k in visibleRows) {
                if (visibleRows[k][1] === true) $("#" + visibleRows[k][0]).addClass('visible');
            }
        }

        if (this.options['group']) {
            if (this.options['debug']) tmSt('_refresh: show_group_remove');
            //удалять надо до рендера новых элементов, чтобы не было повторений id у строк
            var findClass = '.same-hotels';
            this.element.find((isTable ? 'tr' : '') + findClass).remove();
            this.element.find('.more-hotels-open').removeClass('more-hotels-open');
            if (this.options['debug']) tmEnd('_refresh: show_group_remove');
        }

        if (showArr.length > 0) {
            this._renderTableItems({showArr: showArr, visibleRows: visibleRows, do_vis: do_vis});
        }
        if (this.options['debug']) tmEnd('_refresh: show');

        if (this.options['group']) {
            if (this.options['debug']) tmSt('_refresh: show_group');
            //выполнять после рендера, когда все строки отрисованы
            this.element.find('.more-hotels').removeClass('visible');
            var h = '',
                texts = this.options['texts']['same'], $item;
            for (group_key in sameHotels) {
                row_id = sameHotels[group_key].shift();
                if (sameHotels[group_key].length > 0) {
                    $item = $("#mh" + row_id);
                    h = '<span>Еще ' + sameHotels[group_key].length + ' ' +
                        getnoun(sameHotels[group_key].length, texts[0], texts[1], texts[2]) + '</span>';
                    if (this.options.openedHotels[group_key] && visibleRowsObj.hasOwnProperty('r' + row_id)) {
                        $item.data('text', h).addClass('more-hotels-open');
                        if (this.options['moreHotelsPlace'] != 'mpopup') {
                            h = '<span>Скрыть</span>';
                        }
                        this.showSameHotels(row_id);
                    }
                    $item.html(h).addClass('visible');
                }
            }
            //console.log('отброшено '+q);
            if (this.options['debug']) tmEnd('_refresh: show_group');
        }

        if (visibleRows.length === 0 && this.options.templates.zeroVisibleItem.length !== 0) {
            if (isTable) {
                this.element.find('tbody').append(this.options.templates.zeroVisibleItem);
            } else {
                this.element.find('.tbody').append(this.options.templates.zeroVisibleItem);
            }
        }
        if (do_vis && this.options.showHelpLine) {
            if (this.options['debug']) tmSt('_refresh: showHelpLine');
            var tpl = this.options.templates.help.filter;
            for (i = 0; i < visibleRows.length; i += this.options.baseCountView) {
                if (isTable) {
                    this.element.find('tbody tr.visible:not(.striped):eq(' + i + ')').after(tpl);
                } else {
                    this.element.find('.tbody .js_tour_item.visible:not(.striped):eq(' + i + ')').after(tpl);
                }
            }

            tpl = this.options.templates.help.tel;
            for (i = 4; i < visibleRows.length; i += this.options.countView) {
                if (isTable) {
                    this.element
                        .find('tbody tr.visible:not(.striped):eq(' + i + ')')
                        .after(tpl);
                } else {
                    this.element
                        .find('.tbody .js_tour_item.visible:not(.striped):eq(' + i + ')')
                        .after(tpl);
                }
            }

            tpl = this.options.templates.help.includeTemplate;
            for (i = 8; i < visibleRows.length; i += this.options.countView) {
                if (isTable) {
                    this.element
                        .find('tbody tr.visible:not(.striped):eq(' + i + ')')
                        .after(tpl);
                } else {
                    this.element
                        .find('.tbody .js_tour_item.visible:not(.striped):eq(' + i + ')')
                        .after(tpl);
                }
            }

            tpl = this.options.templates.help.mail;
            for (i = 12; i < visibleRows.length; i += this.options.countView) {
                if (isTable) {
                    this.element
                        .find('tbody tr.visible:not(.striped):eq(' + i + ')')
                        .after(tpl);
                } else {
                    this.element
                        .find('.tbody .js_tour_item.visible:not(.striped):eq(' + i + ')')
                        .after(tpl);
                }
            }

            if (this.options['debug']) tmEnd('_refresh: showHelpLine');
        }

        //восстанавливаем значения selected и sended
        if (this.options.selectable) {
            if (this.options['debug']) tmSt('_refresh: selectable');
            if (isTable) {
                this.element.find('tbody tr').removeClass('selected sended');
            } else {
                this.element.find('.tbody .js_tour_item').removeClass('selected sended');
            }
            var cl;
            for (row_id in tableData) {
                dd = tableData[row_id];
                if (!dd['rendered']) continue;
                cl = '';
                if (dd['sended']) cl = 'sended';
                else if (dd['selected']) cl = 'selected';

                if (cl != '') {
                    $('#' + row_id).addClass(cl);
                }
            }
            if (this.options['debug']) tmEnd('_refresh: selectable');
        }

        this.options.pageCount = pCount;
        if (do_vis) this._refreshPagination(cnt);
        return visibleRows;
    },

    _refreshPagination: function (cnt) {
        if (this.options['debug']) tmSt('_refresh: pagination');
        var self = this;
        var $page = this.options.elems.pagination;
        var i;
        //прячем все
        $page.find('li.pagination_item').addClass('hidden').removeClass('active');
        $page.find('li:not(.pagination_item)').removeClass('disabled');
        var $morePagesSign = $page.find('.more-pages-sign');
        $morePagesSign.addClass('transparent');

        var that = this;
        var exCount = $page.find('li.pagination_item').length;	//кол-во существующих
        //дорисовываем недостающие элементы
        var html = '';

        for (i = exCount + 1; i <= this.options.pageCount; i++) {
            html += '<li class="pagination_item hidden" data-page="' + i + '" data-type="page"><a>' + i + '</a></li>';
        }

        if (this.options.mobile) {
            var pagesCount = parseInt(this.options.pageCount, 10);
            if (pagesCount > 0 && exCount === 0) {
                html = '<span class="more-pages-sign start transparent">...</span>' + html;
            }

            $morePagesSign.filter('.end').remove();
            html += '<span class="more-pages-sign end transparent">...</span>';
        }
        $page.find('li.pagination_next').before(html);

        var st = (this.options.page - (this.options.pageButtonCount / 2) >= 1 )
            ? (this.options.page - (this.options.pageButtonCount / 2))
            : 1;
        var end = st + this.options.pageButtonCount;
        if (end > this.options.pageCount) {
            end = this.options.pageCount;
            st = end - this.options.pageButtonCount;
        }

        if (this.options['debug']) cl('-----------------');
        if (this.options['debug']) cl('page: ' + this.options.page);
        if (this.options['debug']) cl('cnt: ' + cnt);
        if (this.options['debug']) cl('st: ' + st);
        if (this.options['debug']) cl('end: ' + end);
        if (this.options['debug']) cl('-----------------');

        var isFirstPageVisible = false;
        var isLastPageVisible = false;
        $page.find('li.pagination_item').each(function () {
            var p = $(this).data('page');
            if (p >= st && p <= end) {
                if (p == 1) {
                    isFirstPageVisible = true;
                }
                if (p == self.options.pageCount) {
                    isLastPageVisible = true;
                }
                $(this).removeClass('hidden');
            }
            if (p == that.options.page) {
                $(this).addClass('active');
            }
        });


        if (!isLastPageVisible) {
            $page.find('.more-pages-sign.end').removeClass('transparent');
        }
        if (!isFirstPageVisible) {
            $page.find('.more-pages-sign.start').removeClass('transparent');
        }

        /*дисаблим крайние кнопки если надо*/
        if (this.options.page == 1) {
            $page.find('li[data-type=start], li[data-type=prev]').addClass('disabled');
        }
        if (this.options.page == this.options.pageCount) {
            $page.find('li[data-type=end], li[data-type=next]').addClass('disabled');
        }

        if (this.options['debug']) tmEnd('_refresh: pagination');
    },

    //добавление элемента в DOM
    renderItems: function (params) {
        var tableData = this.options['data'],
            k, row, row_id, showArr = [], visibleRows = [];
        for (k in params.items) {
            row_id = 'r' + params.items[k];
            row = tableData[row_id];
            if (row['rendered']) continue;
            showArr.push(row_id);
            visibleRows.push([row_id, false]);
        }
        this._renderTableItems({
            showArr: showArr,
            visibleRows: visibleRows
        });
        this._refresh();
    },
    //рисуем элемент
    _renderTableItems: function (params) {
        if (this.options['debug']) tmSt('_refresh: _renderTableItems');
        //showArr, visibleRows, do_vis
        var tableData = this.options['data'], showArr = params.showArr || [],
            visibleRows = params.visibleRows || [], that = this,
            ind, row, i,
            do_vis = 'do_vis' in params ? params.do_vis : true;

        /*
         var htmlArr = [];
         for(k in showArr){
         ind = showArr[k];
         row = tableData[ind]['values'];
         htmlArr[ind] = this.createRowHtml(row);
         }
         */

        if (this.options['debug']) tmSt('_refresh: _renderTableItems: insert (' + showArr.length + ')');
        var prev = -1, html = '';
        //visibleRows.reverse();
        /*
         var p = null, pid = null;
         for(i in tableData){
         if(p != null && p > tableData[i]['values']['price']){
         console.log('tableData sort error', p, tableData[i]['values']['price'], i);
         }
         p = tableData[i]['values']['price'];
         }
         p = null;
         visibleRows.forEach(function(row, i){
         if(p && tableData[row[0]]['values']['price'] < tableData[p]['values']['price']){
         console.log('visible sort error', row[0], p, i);
         }
         p = row[0];
         });
         p = null;
         $("tbody tr:visible", "#results").each(function(){
         var cur_price = parseInt($(this).find('.price input').val()),
         id = $(this).prop('id');
         if(p != null && cur_price < p){
         console.log('sort error', cur_price, p, id, pid, visibleRows);
         debugger;
         }
         p = cur_price;
         pid = id;
         });
         */
        var $body = that.element.find((this.options.isTable ? '' : '.') + 'tbody');
        var len = visibleRows.length;
        for (i = 0; i < len; i++) {
            row = visibleRows[i];
            if (!row[1]) {    //если элемент не отрисован
                html += that.createRowHtml(tableData[row[0]]['values']);// + html;
                tableData[row[0]]['rendered'] = true;
            } else {          //если элемент отрисован
                if (html != "") {
                    //если html не пустой, вставляем его
                    if (prev == -1) {
                        $body.prepend(html);
                    } else {
                        $(html).insertAfter($("#" + prev));
                    }
                    html = "";
                }
                prev = row[0];
            }
        }
        if (html != "") {
            if (prev == -1) {
                $body.prepend(html);
            } else {
                $(html).insertAfter($("#" + prev));
            }
        }
        /*
         p = null;
         pid = null;
         $("tbody tr:visible", "#results").each(function(){
         var cur_price = parseInt($(this).find('.price input').val()),
         id = $(this).prop('id');
         if(p != null && cur_price < p){
         console.log('sort error', cur_price, p, id, pid, visibleRows);
         var pvr = null;
         visibleRows.forEach(function(row, i){
         if(row[0] == id) console.log('cur_visible_row', i);
         if(row[0] == pid) console.log('prev_visible_row', i);
         if(pvr && tableData[row[0]]['values']['price'] < tableData[pvr]['values']['price']){
         console.log('visible sort error', row[0], pvr, i);
         }
         pvr = row[0];
         });
         debugger;
         }
         p = cur_price;
         pid = id;
         });
         */
        /*
         var cnt = visibleRows.length, is_new = false, insArr = [], ar, row_id;
         for (i=0;i<visibleRows.length;i++){
         ar = visibleRows[i];
         row_id = ar[0];
         is_new = (ar[1] == false);
         if(prev != -1){
         insArr[prev] = row_id;
         }
         prev = -1;
         if(is_new) prev = row_id;
         }
         if(prev != -1){
         this.element.find('tbody').append(htmlArr[prev]);
         }

         //Вставляем в DOM
         var keys = [];

         for (var k in insArr) {
         keys.unshift(k);
         }

         for (var c = keys.length, n = 0; n < c; n++) {
         key = keys[n];
         var h = htmlArr[key] || "";
         $(h).insertBefore($("#"+insArr[key]));
         tableData[key]['new'] = false;
         }
         */
        if (this.options['debug']) tmEnd('_refresh: _renderTableItems: insert (' + showArr.length + ')');
        /*
         for(k in showArr){
         row_id = showArr[k];
         tableData[row_id]['rendered'] = true;
         }
         */
        this._setOption('data', tableData);

        if (this.options['debug']) tmEnd('_refresh: _renderTableItems');
    },

    _sortByPrice: function (a, b) {
        if (a['values']['price'] > b['values']['price']) return 1;
        if (a['values']['price'] < b['values']['price']) return -1;
        return 0;
    },

    //Добавление комментария
    setComment: function (params) {
        var id = params.id;
        var text = params.text;
        var old_comm = this.options['data']['r' + id]['comment'] || "";
        this.options['data']['r' + id].comment = text;
        this.options['data']['r' + id].commentTemplate = params.template;
        this.options['data']['r' + id].commentTemplateText = params.templateText;
        //удаляем комментарий
        if (text == '') {
            $("#r" + id).find('.comm').remove();
        } else {
            //добаляем/обновляем комментарий
            if (old_comm == '') {	//Добавляем
                $("#r" + id + " td.hotel-comment-wrap").html('<span class="fl_r comm hotel_comment"><img src="/img/hico/comm.png" /></span>');
            } else {	//обновляем

            }
        }

    },
    //Удаление строки из таблицы
    removeRow: function (id) {
        //удалить из filters
        if (this.options['debug']) tmSt('removeRow');
        id = 'r' + id;
        var row = this.options['data'][id] || null;
        if (row == null) return;

        var filters = this.options['filters'];
        for (var ff_key in filters) {
            if (!row[ff_key]) continue;
            var ff = filters[ff_key];
            var f_val = row[ff_key];
            ff['values'][f_val]['all_count']--;
            filters[ff_key] = ff;
        }
        //удаляем хэш
        if (this.options.useHash) {
            delete this.options['hashList'][row['hash']];
        }
        //удалить из tableData
        delete this.options['data'][id];
        //удалить из DOM
        $("#" + id).remove();
        //пересчитать, показывать ли строку
        this._checkVisible();
        //обновить фильтр
        this.refreshFilter();
        //обновляем таблицу
        this._refresh();
        if (this.options['debug']) tmEnd('removeRow');
    },
    //удаление строк из DOM
    removeRowsFromDOM: function (rowIds) {
        var k, id,
            data = this.options.data;
        for (k in rowIds) {
            id = rowIds[k];
            $("#" + id).addClass('need-remove');
            data[id]['rendered'] = false;
        }
        $('.need-remove', this.element).remove();
        this._setOption('data', data);
    },
    //удаление всех строк из DOM
    removeAllRowsFromDOM: function () {
        if (this.options['debug']) tmSt('removeAllRowsFromDOM');
        var k, id,
            data = this.options.data;
        for (id in data) {
            data[id]['rendered'] = false;
        }
        if (this.options.isTable) {
            this.element.find('tbody tr').remove();
        } else {
            this.element.find('.tbody .js_tour_item').remove();
        }
        this._setOption('data', data);
        if (this.options['debug']) tmEnd('removeAllRowsFromDOM');
    },
    //Удаление нескольких строк из БД
    removeRows: function (rowIds, ref) {
        if (this.options['debug']) tmSt('removeRows');
        if (undefined === ref) ref = true;
        var delArr = [], id;
        for (var k in rowIds) {
            id = rowIds[k];
            var row = this.options['data'][id] || null;
            if (row == null) return;
            //удалить из filters
            var filters = this.options['filters'];
            for (var ff_key in filters) {
                if (!filters.hasOwnProperty(ff_key)) {
                    continue;
                }
                if (!row['values'][ff_key]) continue;
                var ff = filters[ff_key];
                var f_val = row['values'][ff_key];
                if (!ff['values'][f_val]) continue;
                ff['values'][f_val]['all_count']--;
                ff['values'][f_val]['count']--;
                filters[ff_key] = ff;
            }
            //удаляем хэш
            if (this.options.useHash) {
                delete this.options['hashList'][row['hash']];
            }
            //удалить из tableData
            delete this.options['data'][id];

            //удалить из DOM
            $("#" + id).addClass('need-remove');
            // delArr.push("#"+id);
        }
        // $(delArr.join(',')).remove();
        $('.need-remove', this.element).remove();
        if (ref) {
            //пересчитать, показывать ли строку
            this._checkVisible();
            //обновить фильтр
            this.refreshFilter();
            //обновляем таблицу
            this._refresh();
        }

        if (this.options['debug']) tmEnd('removeRows');
    },

    _resortTuples: function (tuples) {
        var that = this;
        return tuples.sort(function(a, b) {
            var valueA = a[1]['values'][that.options.sortBy];
            var valueB = b[1]['values'][that.options.sortBy];
            var priceA = a[1]['values']['price'];
            var priceB = b[1]['values']['price'];
            var res = 0;
            switch (that.options.sortFilters[that.options.sortBy]['direct']) {
                case 'DESC':
                    res = valueA < valueB ? 1 : (valueA > valueB ? -1 : 0);
                    if (res === 0 && that.options.sortBy === 'popularity') {
                        res = priceA < priceB ? -1 : (priceA > priceB ? 1 : 0);
                    }
                    break;
                default:
                    res = valueA < valueB ? -1 : (valueA > valueB ? 1 : 0);
                    if (res === 0 && that.options.sortBy === 'popularity') {
                        res = priceA < priceB ? -1 : (priceA > priceB ? 1 : 0);
                    }
                    break;
            }
            return res;
        });
    },

    //пересортиврока данных
    resort: function () {
        if (this.options['debug']) tmSt('resort');
        var id, value, data = this.options.data;
        //сортируем по возрастанию цены
        var tuples = [];
        for (id in data) tuples.push([id, data[id]]);
        var that = this;
        tuples = this._resortTuples(tuples);

        var td = {};
        for (var i = 0; i < tuples.length; i++) {
            id = tuples[i][0];
            value = tuples[i][1];
            td[id] = value;
        }
        data = td;
        this._setOption('data', data);
        if (this.options['debug']) tmEnd('resort');
    },

    updateFilter: function (field) {
        var filters = this.options['filters'];
        if (filters.hasOwnProperty(field)) {
            filters[field]['forceUpdate'] = true;
            this._setOption('filters', filters);
            this.refresh();
        }
    },


    /**
     * @param {string} urlParams
     */
    setTourViewUrlParams: function(urlParams) {
        this.options.tourViewUrlParams = urlParams;
    },
});

$(document).ready(function () {
    $('#results tbody, #results .tbody').on('click', '.showHotelInfo', function (e) {
        var $table = $('#results');
        var isTable = $table.is('table');

        var par = isTable ? $(this).closest('tr') : $(this).closest('.js_tour_item'),
            targetTab = $(this).data('target-tab'),
            operator = par.data('operator'),
            parData = par.data(),
            data = $(this).data();

        var popupParams = {
            page_url: '/tours/hotel/info?' +
                'tour=' + (data.tourType || parData.tourType || '') + (data.id || parData.id) + '&' +
                'price=' + (data.price || parData.price) +
                ($('#results').hasClass('fullPrice') ? '&fullPrice=1' : '')
                + (targetTab ? '&targetTab=' + targetTab : '')
                + (operator ? '&operator=' + operator : '') +
                '&notConvertPrices=' + (window.notConvertShowHotelPrices ? 1 : '') +
                '&fromFind=' + ( isTable ? ($("#frmFind, .w-search_form").length ? 1 : 0) : ( (window.location.pathname.indexOf('findtours') + 1) ? 1 : 0) ),
        };
        popup2(popupParams);
        e.stopPropagation();
    });
});

function debug(str) {
    console.debug(str);
}

function log(str) {
    console.log(str);
}

function tmSt(str) {
    console.time(str);
}

function tmEnd(str) {
    console.timeEnd(str);
}

function find(array, value) {
    if (array.indexOf) { // если метод существует
        return array.indexOf(value);
    }

    for (var i = 0; i < array.length; i++) {
        if (array[i] === value) return i;
    }

    return -1;
}
